import React, { useEffect, useState } from 'react';
import axios from 'axios';
import firebase from "firebase/compat/app";
import { firebaseConfig } from './firebase';

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import BedIcon from '@mui/icons-material/Bed';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BathtubIcon from '@mui/icons-material/Bathtub';
import GrassIcon from '@mui/icons-material/Grass';
import ConstructionIcon from '@mui/icons-material/Construction';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import VillaIcon from '@mui/icons-material/Villa';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FoundationIcon from '@mui/icons-material/Foundation';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import EmailIcon from '@mui/icons-material/Email';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import FenceIcon from '@mui/icons-material/Fence';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx';
import { Button } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import { doSignOut } from "./auth.js";
import { useAuth } from "./authContext";
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardMedia } from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";
import StateModal from "./StateModal.jsx";
import TenantModal from "./TenantModal.jsx";
import UpsellModal from './UpsellModal.jsx';
import ProfileComponent from './ProfileComponent.jsx';
import ZillowClonePage from './ZillowClonePage.jsx';

// Fix leaflet default icon issues
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// =====================================================================
// New ZillowClonePage component with a two-panel layout (map & listings)
// =====================================================================

// =====================================================================
// Main DealExplorer2 Component (your existing code with sidebar)
// =====================================================================
firebase.initializeApp(firebaseConfig);

const DealExplorer2 = () => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: ''
  });
  const [resultData, setResultData] = useState(null);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  console.log(resultData);

  const DealExplorerUpsell = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Deal Explorer</button>
        <UpsellModal open={open} onClose={handleClose} />
      </>
    );
  };

  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Housing Authority</button>
        <StateModal open={open} onClose={handleClose} />
      </>
    );
  };

  const OpenModalButton2 = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Tenant Lookup</button>
        <TenantModal open={open} onClose={handleClose} />
      </>
    );
  };


  const currentListingsMemphis = [
    {
        "id": "3371-Emmons-Rd,-Memphis,-TN-38128",
        "formattedAddress": "3371 Emmons Rd, Memphis, TN 38128",
        "imgSrc":"https://photos.zillowstatic.com/fp/03c816d5932eadbb1c1e25854a47aa8e-cc_ft_768.webp",
        "addressLine1": "3371 Emmons Rd",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38128",
        "county": "Shelby",
        "latitude": 35.206819,
        "longitude": -89.951161,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "lotSize": 17860,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 280000,
        "listingType": "New Construction",
        "listedDate": "2022-05-12T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-05-12T13:59:51.065Z",
        "lastSeenDate": "2025-02-05T11:27:25.556Z",
        "daysOnMarket": 1001,
        "mlsName": "Memphis",
        "mlsNumber": "10123754",
        "listingAgent": {
            "name": "Infinity Group Realtors, Daryl Lewis",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com",
            "website": "http://infinitygrouprealtors.com/"
        },
        "listingOffice": {
            "name": "Infinity Group Realtors, Inc.",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com"
        },
        "history": {
            "2022-05-12": {
                "event": "Sale Listing",
                "price": 280000,
                "listingType": "New Construction",
                "listedDate": "2022-05-12T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 1001
            }
        }
    },
    {
        "id": "704-Bethel-Ave,-Memphis,-TN-38107",
        "formattedAddress": "704 Bethel Ave, Memphis, TN 38107",
        "imgSrc":"https://photos.zillowstatic.com/fp/8f6cb197f2ba08d342555b817b152dcb-cc_ft_768.webp",
        "addressLine1": "704 Bethel Ave",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38107",
        "county": "Shelby",
        "latitude": 35.163175,
        "longitude": -90.034462,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1.5,
        "lotSize": 7841,
        "yearBuilt": 1912,
        "status": "Active",
        "price": 205000,
        "listingType": "Standard",
        "listedDate": "2023-08-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-08-25T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.464Z",
        "daysOnMarket": 532,
        "mlsName": "Memphis",
        "mlsNumber": "10155097",
        "listingAgent": {
            "name": "Randall Weatherall",
            "phone": "7314875843",
            "email": "randall@memphis-metro.com"
        },
        "listingOffice": {
            "name": "Memphis Metro Realty",
            "phone": "9013526200",
            "email": "ryan@memphis-metro.com"
        },
        "history": {
            "2023-08-24": {
                "event": "Sale Listing",
                "price": 205000,
                "listingType": "Standard",
                "listedDate": "2023-08-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 532
            }
        }
    },
    {
        "id": "2151-Goff-Ave,-Memphis,-TN-38114",
        "imgSrc":
        ["https://photos.zillowstatic.com/fp/b6478afc29503479a850763a1bc0bd95-cc_ft_768.webp",
  'https://photos.zillowstatic.com/fp/2fec189ac0972fbd5209bf4e3e4bce22-cc_ft_384.webp',
  'https://photos.zillowstatic.com/fp/43f542d8df105f18add89d889a9cb4d5-cc_ft_768.webp'
    ],
        "formattedAddress": "2151 Goff Ave, Memphis, TN 38114",
        "addressLine1": "2151 Goff Ave",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38114",
        "county": "Shelby",
        "latitude": 35.100864,
        "longitude": -89.991229,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "lotSize": 4792,
        "yearBuilt": 1927,
        "status": "Active",
        "price": 24900,
        "listingType": "Standard",
        "listedDate": "2023-09-13T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-14T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.463Z",
        "daysOnMarket": 512,
        "mlsName": "Memphis",
        "mlsNumber": "10156596",
        "listingAgent": {
            "name": "Tyler Bowman",
            "phone": "9015178564",
            "email": "tylerwbowman@yahoo.com"
        },
        "listingOffice": {
            "name": "Weichert, REALTORS-Benchmark, LLC",
            "phone": "9012022000",
            "email": "kgilliam@benchmarkrealtors.com",
            "website": "http://www.benchmarkmemphis.com"
        },
        "history": {
            "2023-09-13": {
                "event": "Sale Listing",
                "price": 24900,
                "listingType": "Standard",
                "listedDate": "2023-09-13T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 512
            },
            
        }
    },
    {
        "id": "3279-Hanna-Dr,-Memphis,-TN-38128",
        "imgSrc":  'https://photos.zillowstatic.com/fp/9cc49765bc6a4760e8093df3e0a351e4-cc_ft_768.webp' ,
        "formattedAddress": "3279 Hanna Dr, Memphis, TN 38128",
        "addressLine1": "3279 Hanna Dr",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38128",
        "county": "Shelby",
        "latitude": 35.215197,
        "longitude": -89.922236,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1.5,
        "lotSize": 8712,
        "yearBuilt": 1964,
        "status": "Active",
        "price": 127116,
        "listingType": "Standard",
        "listedDate": "2022-10-23T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-10-23T08:50:14.033Z",
        "lastSeenDate": "2025-02-05T11:27:25.459Z",
        "daysOnMarket": 837,
        "mlsName": "MyStateMLS",
        "mlsNumber": "11116280",
        "listingAgent": {
            "name": "Brian Brockman",
            "phone": "5138981551",
            "email": "brian@brianbrockman.com",
            "website": "http://www.bangrealty.com/"
        },
        "listingOffice": {
            "name": "Bang Realty",
            "phone": "8776192264",
            "email": "fsbo@bangrealty.com"
        },
        "history": {
            "2022-10-23": {
                "event": "Sale Listing",
                "price": 127116,
                "listingType": "Standard",
                "listedDate": "2022-10-23T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 837
            }
        }
    },
    {
        "id": "1336-Peabody-Ave,-Memphis,-TN-38104",
        "formattedAddress": "1336 Peabody Ave Memphis, TN 38104",
        "addressLine1": "1336 Peabody Ave",
        "imgSrc":'https://photos.zillowstatic.com/fp/d39188f495bb99b0f4605b341723627c-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38104",
        "county": "Shelby",
        "latitude": 35.132944,
        "longitude": -90.01705,
        "propertyType": "Single Family",
        "bedrooms": 5,
        "bathrooms": 3,
        "lotSize": 7500,
        "yearBuilt": 1900,
        "status": "Active",
        "price": 595000,
        "listingType": "Standard",
        "listedDate": "2023-05-09T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-05-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.455Z",
        "daysOnMarket": 639,
        "mlsName": "Memphis",
        "mlsNumber": "10147577",
        "listingAgent": {
            "name": "Erin Parish"
        },
        "listingOffice": {
            "name": "Harris Realty Service",
            "phone": "9013728003",
            "email": "kharris@hrsmemphis.com",
            "website": "hrsmemphis.com"
        },
        "history": {
            "2023-05-09": {
                "event": "Sale Listing",
                "price": 595000,
                "listingType": "Standard",
                "listedDate": "2023-05-09T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 639
            }
        }
    },
    {
        "id": "3152-Larkspur-Dr,-Memphis,-TN-38111",
        "formattedAddress": "3152 Larkspur Dr, Memphis, TN 38111",
        "addressLine1": "3152 Larkspur Dr",
        "imgSrc":
        [
        'https://photos.zillowstatic.com/fp/feed8a5677e5e27047011dbd982d2c88-cc_ft_768.webp',
        'https://photos.zillowstatic.com/fp/bfff81714d4e1b4298754176166eda6c-cc_ft_768.webp',
        'https://photos.zillowstatic.com/fp/0a260ea83fa9d98be662cc5f16f44a91-cc_ft_768.webp'
      ],
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38111",
        "county": "Shelby",
        "latitude": 35.10264,
        "longitude": -89.957498,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "lotSize": 7308,
        "yearBuilt": 1951,
        "status": "Active",
        "price": 78000,
        "listingType": "Standard",
        "listedDate": "2023-05-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-05-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.453Z",
        "daysOnMarket": 640,
        "mlsName": "Memphis",
        "mlsNumber": "10147530",
        "listingAgent": {
            "name": "Lisa Y Chairs",
            "phone": "9017678770",
            "email": "lisaychairs@att.net"
        },
        "listingOffice": {
            "name": "BEST Real Estate Company",
            "phone": "9014072177",
            "email": "successsavvy1@gmail.com",
            "website": "http://www.bestrealestateco.com"
        },
        "history": {
            "2023-05-08": {
                "event": "Sale Listing",
                "price": 78000,
                "listingType": "Standard",
                "listedDate": "2023-05-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 640
            }
        }
    },
    {
        "id": "4764-Aloha-Ave,-Memphis,-TN-38118",
        "formattedAddress": "4764 Aloha Ave, Memphis, TN 38118",
        "addressLine1": "4764 Aloha Ave",
        "imgSrc":'https://photos.zillowstatic.com/fp/5d92303660c082b87c974cc596c974e7-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38118",
        "county": "Shelby",
        "latitude": 35.065928,
        "longitude": -89.904978,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "lotSize": 10019,
        "yearBuilt": 1959,
        "status": "Active",
        "price": 145000,
        "listingType": "Standard",
        "listedDate": "2022-11-09T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-03-23T12:17:19.782Z",
        "lastSeenDate": "2025-02-05T11:27:25.446Z",
        "daysOnMarket": 820,
        "mlsName": "Memphis",
        "mlsNumber": "10137329",
        "listingAgent": {
            "name": "Tyler Tapley",
            "phone": "9018711290",
            "email": "tylertapley@gmail.com",
            "website": "www.tylertapley.com"
        },
        "listingOffice": {
            "name": "Crye-Leike, Inc., REALTORS",
            "phone": "9017568900",
            "email": "stevebrown@crye-leike.com"
        },
        "history": {
            "2022-11-09": {
                "event": "Sale Listing",
                "price": 145000,
                "listingType": "Standard",
                "listedDate": "2022-11-09T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 820
            }
        }
    },
    {
        "id": "958-Semmes-Ave,-Memphis,-TN-38111",
        "formattedAddress": "958 Semmes Ave, Memphis, TN 38111",
        "imgSrc":'https://photos.zillowstatic.com/fp/97b2d5adc7cc00b750a5e72f91ea624f-cc_ft_768.webp',
  
        "addressLine1": "958 Semmes Ave",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38111",
        "county": "Shelby",
        "latitude": 35.105746,
        "longitude": -89.961399,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "lotSize": 4356,
        "yearBuilt": 1943,
        "status": "Active",
        "price": 95000,
        "listingType": "Standard",
        "listedDate": "2023-12-15T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-16T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.445Z",
        "daysOnMarket": 419,
        "mlsName": "Memphis",
        "mlsNumber": "10162678",
        "listingAgent": {
            "name": "Tyler Tapley",
            "phone": "9018711290",
            "email": "tylertapley@gmail.com",
            "website": "www.tylertapley.com"
        },
        "listingOffice": {
            "name": "Crye-Leike, Inc., REALTORS",
            "phone": "9017568900",
            "email": "stevebrown@crye-leike.com"
        },
        "history": {
            "2023-12-15": {
                "event": "Sale Listing",
                "price": 95000,
                "listingType": "Standard",
                "listedDate": "2023-12-15T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 419
            }
        }
    },
    {
        "id": "5489-Lake-Vernell-Dr,-Memphis,-TN-38109",
        "formattedAddress": "5489 Lake Vernell Dr, Memphis, TN 38109",
        "addressLine1": "5489 Lake Vernell Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/9ea7f008cc4691c9c0b2d8ab2e3b6c00-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 34.998272,
        "longitude": -90.071658,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3.5,
        "lotSize": 11761,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 25
        },
        "status": "Active",
        "price": 385990,
        "listingType": "New Construction",
        "listedDate": "2023-09-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-25T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.443Z",
        "daysOnMarket": 501,
        "mlsName": "Memphis",
        "mlsNumber": "10157420",
        "listingAgent": {
            "name": "Infinity Group Realtors, Daryl Lewis",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com",
            "website": "http://infinitygrouprealtors.com/"
        },
        "listingOffice": {
            "name": "Infinity Group Realtors, Inc.",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com"
        },
        "history": {
            "2023-09-24": {
                "event": "Sale Listing",
                "price": 385990,
                "listingType": "New Construction",
                "listedDate": "2023-09-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 501
            }
        }
    },
    {
        "id": "5511-Lake-Vernell-Dr,-Memphis,-TN-38109",
        "formattedAddress": "5511 Lake Vernell Dr, Memphis, TN 38109",
        "addressLine1": "5511 Lake Vernell Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/98d9e7260457fbb6608ae0c2c50f070b-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 34.998003,
        "longitude": -90.071213,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3,
        "lotSize": 16553,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 25
        },
        "status": "Active",
        "price": 385120,
        "listingType": "New Construction",
        "listedDate": "2023-09-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-25T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.432Z",
        "daysOnMarket": 501,
        "mlsName": "Memphis",
        "mlsNumber": "10157422",
        "listingAgent": {
            "name": "Infinity Group Realtors, Daryl Lewis",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com",
            "website": "http://infinitygrouprealtors.com/"
        },
        "listingOffice": {
            "name": "Infinity Group Realtors, Inc.",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com"
        },
        "history": {
            "2023-09-24": {
                "event": "Sale Listing",
                "price": 385120,
                "listingType": "New Construction",
                "listedDate": "2023-09-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 501
            }
        }
    },
    {
        "id": "5481-Lake-Vernell-Dr,-Memphis,-TN-38109",
        "formattedAddress": "5481 Lake Vernell Dr, Memphis, TN 38109",
        "addressLine1": "5481 Lake Vernell Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/ffa8b37bbabdcf69c034b54a3e5e7e7f-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 34.998404,
        "longitude": -90.071872,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3.5,
        "lotSize": 11761,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 25
        },
        "status": "Active",
        "price": 405405,
        "listingType": "New Construction",
        "listedDate": "2023-09-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-25T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.428Z",
        "daysOnMarket": 501,
        "mlsName": "Memphis",
        "mlsNumber": "10157419",
        "listingAgent": {
            "name": "Infinity Group Realtors, Daryl Lewis",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com",
            "website": "http://infinitygrouprealtors.com/"
        },
        "listingOffice": {
            "name": "Infinity Group Realtors, Inc.",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com"
        },
        "history": {
            "2023-09-24": {
                "event": "Sale Listing",
                "price": 405405,
                "listingType": "New Construction",
                "listedDate": "2023-09-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 501
            }
        }
    },
    {
        "id": "5497-Lake-Vernell-Dr,-Memphis,-TN-38109",
        "formattedAddress": "5497 Lake Vernell Dr, Memphis, TN 38109",
        "addressLine1": "5497 Lake Vernell Dr",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/6b1cf7c4680726b28507a958257349e0-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 34.998133,
        "longitude": -90.071451,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3.5,
        "lotSize": 12197,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 25
        },
        "status": "Active",
        "price": 370330,
        "listingType": "New Construction",
        "listedDate": "2023-09-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-25T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.425Z",
        "daysOnMarket": 501,
        "mlsName": "Memphis",
        "mlsNumber": "10157421",
        "listingAgent": {
            "name": "Infinity Group Realtors, Daryl Lewis",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com",
            "website": "http://infinitygrouprealtors.com/"
        },
        "listingOffice": {
            "name": "Infinity Group Realtors, Inc.",
            "phone": "9015025894",
            "email": "infinitygrouprealtors@gmail.com"
        },
        "history": {
            "2023-09-24": {
                "event": "Sale Listing",
                "price": 370330,
                "listingType": "New Construction",
                "listedDate": "2023-09-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 501
            }
        }
    },
    {
        "id": "2843-Woodlawn-Ter,-Memphis,-TN-38127",
        "formattedAddress": "2843 Woodlawn Ter, Memphis, TN 38127",
        "addressLine1": "2843 Woodlawn Ter",
        "imgSrc":'https://photos.zillowstatic.com/fp/7644d749c5206a578582622145c1f680-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38127",
        "county": "Shelby",
        "latitude": 35.203127,
        "longitude": -89.997713,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "lotSize": 9583,
        "yearBuilt": 1948,
        "status": "Active",
        "price": 49900,
        "listingType": "Standard",
        "listedDate": "2023-10-10T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2020-10-18T08:34:12.357Z",
        "lastSeenDate": "2025-02-05T11:27:25.420Z",
        "daysOnMarket": 485,
        "mlsName": "Memphis",
        "mlsNumber": "10158487",
        "listingAgent": {
            "name": "Dean Harris",
            "phone": "9016196170",
            "email": "dean@crestcore.com"
        },
        "listingOffice": {
            "name": "CrestCore Realty MphsBrokerage",
            "phone": "9013853119",
            "email": "douglas@crestcore.com"
        },
        "history": {
            "2023-10-10": {
                "event": "Sale Listing",
                "price": 49900,
                "listingType": "Standard",
                "listedDate": "2023-10-10T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 485
            }
        }
    },
    {
        "id": "5367-Shady-Breeze-Cv,-Memphis,-TN-38119",
        "formattedAddress": "5367 Shady Breeze Cv, Memphis, TN 38119",
        "addressLine1": "5367 Shady Breeze Cv",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/60505b05ff512842fd2907084e9f73ff-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38119",
        "county": "Shelby",
        "latitude": 35.094883,
        "longitude": -89.882979,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3,
        "lotSize": 10454,
        "yearBuilt": 2022,
        "status": "Active",
        "price": 794800,
        "listingType": "New Construction",
        "listedDate": "2023-10-27T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-10-14T13:21:02.129Z",
        "lastSeenDate": "2025-02-05T11:27:25.416Z",
        "daysOnMarket": 468,
        "mlsName": "Memphis",
        "mlsNumber": "10159721",
        "listingAgent": {
            "name": "Worth Jones",
            "phone": "9012891890",
            "email": "worth@warejones.com",
            "website": "http://www.warejones.com"
        },
        "listingOffice": {
            "name": "Ware Jones REALTORS",
            "phone": "9014504011",
            "email": "wware@warejones.com"
        },
        "history": {
            "2023-10-27": {
                "event": "Sale Listing",
                "price": 794800,
                "listingType": "New Construction",
                "listedDate": "2023-10-27T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 468
            }
        }
    },
    {
        "id": "6005-Wild-Oaks-Dr,-Memphis,-TN-38120",
        "formattedAddress": "6005 Wild Oaks Dr, Memphis, TN 38120",
        "addressLine1": "6005 Wild Oaks Dr",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/94552b2d9e531a56de38db7a81a71b5d-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38120",
        "county": "Shelby",
        "latitude": 35.116497,
        "longitude": -89.861723,
        "propertyType": "Single Family",
        "bedrooms": 5,
        "bathrooms": 6.5,
        "lotSize": 26136,
        "yearBuilt": 2007,
        "status": "Active",
        "price": 2000000,
        "listingType": "Standard",
        "listedDate": "2023-08-29T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2020-09-21T21:41:55.603Z",
        "lastSeenDate": "2025-02-05T11:27:25.412Z",
        "daysOnMarket": 527,
        "mlsName": "Memphis",
        "mlsNumber": "10155457",
        "listingAgent": {
            "name": "James Harvey Jr",
            "phone": "9012290566",
            "email": "jamesharveyjr@kw.com",
            "website": "http://www.thejamesharveygroup.com"
        },
        "listingOffice": {
            "name": " Keller Williams Realty",
            "phone": "9012215100",
            "email": "klrw584@kw.com"
        },
        "history": {
            "2023-08-29": {
                "event": "Sale Listing",
                "price": 2000000,
                "listingType": "Standard",
                "listedDate": "2023-08-29T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 527
            }
        }
    },
    {
        "id": "2762-Overton-Crossing-Rd,-Memphis,-TN-38127",
        "formattedAddress": "2762 Overton Crossing Rd, Memphis, TN 38127",
        "addressLine1": "2762 Overton Crossing Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/63b7d393b010dcda2e9f3625a0ff9e37-cc_ft_384.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38127",
        "county": "Shelby",
        "latitude": 35.200826,
        "longitude": -90.000783,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "lotSize": 8712,
        "yearBuilt": 1971,
        "status": "Active",
        "price": 121000,
        "listingType": "Standard",
        "listedDate": "2023-12-01T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-01T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.408Z",
        "daysOnMarket": 433,
        "mlsName": "Memphis",
        "mlsNumber": "10161839",
        "listingAgent": {
            "name": "Larrian Currie",
            "phone": "9016905071",
            "email": "larrianc@yahoo.com",
            "website": "http://lchomes.us/"
        },
        "listingOffice": {
            "name": "One Stop Global Realty",
            "phone": "9015900816",
            "email": "larrianc@yahoo.com"
        },
        "history": {
            "2023-12-01": {
                "event": "Sale Listing",
                "price": 121000,
                "listingType": "Standard",
                "listedDate": "2023-12-01T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 433
            }
        }
    },
    {
        "id": "5459-Glenstone-Cv,-Unicorp,-Memphis,-TN-38125",
        "formattedAddress": "5459 Glenstone Cv, Unicorp, Memphis, TN 38125",
        "addressLine1": "5459 Glenstone Cv",
        "imgSrc":'https://photos.zillowstatic.com/fp/25c26bf3adb41c7930a4aa3ddcb738d1-cc_ft_768.webp',
  
        "addressLine2": "Unicorp",
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38125",
        "county": "Shelby",
        "latitude": 34.9972,
        "longitude": -89.8093,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3,
        "lotSize": 8067,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 32
        },
        "status": "Active",
        "price": 434900,
        "listingType": "Standard",
        "listedDate": "2023-11-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-09-24T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.399Z",
        "daysOnMarket": 456,
        "mlsName": "Memphis",
        "mlsNumber": "10160513",
        "listingAgent": {
            "name": "Leon Dickson",
            "phone": "9014619717",
            "email": "ldicksonsr@yahoo.com"
        },
        "listingOffice": {
            "name": "Benchmark At Southwind, Llc",
            "phone": "9016929253",
            "email": "leondicksonsr@gmail.com"
        },
        "history": {
            "2023-11-08": {
                "event": "Sale Listing",
                "price": 434900,
                "listingType": "Standard",
                "listedDate": "2023-11-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 456
            }
        }
    },
    {
        "id": "9029-Red-Tulip-Cv,-Memphis,-TN-38018",
        "formattedAddress": "9029 Red Tulip Cv, Memphis, TN 38018",
        "addressLine1": "9029 Red Tulip Cv",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/2624f850718db695edd5cb1bfc3c2d46-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38018",
        "county": "Shelby",
        "latitude": 35.119453,
        "longitude": -89.761836,
        "propertyType": "Single Family",
        "bedrooms": 5,
        "bathrooms": 4,
        "lotSize": 14810,
        "yearBuilt": 2023,
        "status": "Active",
        "price": 850000,
        "listingType": "New Construction",
        "listedDate": "2023-12-01T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-02T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:27:25.396Z",
        "daysOnMarket": 433,
        "mlsName": "Memphis",
        "mlsNumber": "10161925",
        "listingAgent": {
            "name": "James Harvey Jr",
            "phone": "9012290566",
            "email": "jamesharveyjr@kw.com",
            "website": "http://www.thejamesharveygroup.com"
        },
        "listingOffice": {
            "name": " Keller Williams Realty",
            "phone": "9012215100",
            "email": "klrw584@kw.com"
        },
        "history": {
            "2023-12-01": {
                "event": "Sale Listing",
                "price": 850000,
                "listingType": "New Construction",
                "listedDate": "2023-12-01T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 433
            }
        }
    },
    {
        "id": "3005-Sunrise-Ave,-Memphis,-TN-38127",
        "formattedAddress": "3005 Sunrise Ave, Memphis, TN 38127",
        "addressLine1": "3005 Sunrise Ave",
        "addressLine2": null,
        "imgSrc":['https://photos.zillowstatic.com/fp/9ce0b0293d72051b622689865b01222a-cc_ft_768.webp', 
        'https://photos.zillowstatic.com/fp/591c1d033bda24427e40dbbb1ed06a04-cc_ft_384.webp',
        'https://photos.zillowstatic.com/fp/f668ff6d2959f30ae57836c2576637af-cc_ft_768.webp',
        'https://photos.zillowstatic.com/fp/ead7a0cfda8e7ceff05d767f26a668a6-uncropped_scaled_within_1536_1152.webp'
  
      
      
      ],
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38127",
        "county": "Shelby",
        "latitude": 35.207551,
        "longitude": -90.040349,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "lotSize": 6970,
        "yearBuilt": 1947,
        "status": "Active",
        "price": 80000,
        "listingType": "Standard",
        "listedDate": "2024-01-18T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-19T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:23:50.399Z",
        "daysOnMarket": 385,
        "mlsName": "Memphis",
        "mlsNumber": "10164228",
        "listingAgent": {
            "name": "James Wachob",
            "email": "jameswachob@me.com",
            "website": "http://www.jameswachob.com"
        },
        "listingOffice": {
            "name": "Foundation Property Management",
            "phone": "9016331484",
            "email": "dawn@foundationpm.com"
        },
        "history": {
            "2024-01-18": {
                "event": "Sale Listing",
                "price": 80000,
                "listingType": "Standard",
                "listedDate": "2024-01-18T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 385
            }
        }
    },
    {
        "id": "2096-Farrington-St,-Memphis,-TN-38109",
        "formattedAddress": "2096 Farrington St, Memphis, TN 38109",
        "addressLine1": "2096 Farrington St",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/576490cbd509771cb4e263160310e96a-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 35.09044,
        "longitude": -90.074273,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "lotSize": 5140,
        "yearBuilt": 1948,
        "status": "Active",
        "price": 50000,
        "listingType": "Standard",
        "listedDate": "2024-01-11T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-12T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:23:50.390Z",
        "daysOnMarket": 392,
        "mlsName": "Memphis",
        "mlsNumber": "10163976",
        "listingAgent": {
            "name": "Antonio J. Walton",
            "phone": "9018641203",
            "email": "tonysellshouses2012@gmail.com",
            "website": "http://findmemphisareahouses.com"
        },
        "listingOffice": {
            "name": "The Home Partners Realty",
            "phone": "9013056047",
            "email": "contact@thehomepartnersrealty.com",
            "website": "https://www.thehomepartnersrealty.com/"
        },
        "history": {
            "2024-01-11": {
                "event": "Sale Listing",
                "price": 50000,
                "listingType": "Standard",
                "listedDate": "2024-01-11T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 392
            }
        }
    },
    {
        "id": "1703-Alta-Vista-Dr,-Memphis,-TN-38127",
        "formattedAddress": "1703 Alta Vista Dr, Memphis, TN 38127",
        "addressLine1": "1703 Alta Vista Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/6706cf46c0e37a4a04b8e2acb09492ca-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38127",
        "county": "Shelby",
        "latitude": 35.209146,
        "longitude": -90.007287,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "lotSize": 17860,
        "yearBuilt": 1950,
        "status": "Active",
        "price": 99000,
        "listingType": "Standard",
        "listedDate": "2023-12-30T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-31T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:23:50.333Z",
        "daysOnMarket": 404,
        "mlsName": "Memphis",
        "mlsNumber": "10163231",
        "listingAgent": {
            "name": "Tyler Tapley",
            "phone": "9018711290",
            "email": "tylertapley@gmail.com",
            "website": "www.tylertapley.com"
        },
        "listingOffice": {
            "name": "Crye-Leike, Inc., REALTORS",
            "phone": "9017568900",
            "email": "stevebrown@crye-leike.com"
        },
        "history": {
            "2023-12-30": {
                "event": "Sale Listing",
                "price": 99000,
                "listingType": "Standard",
                "listedDate": "2023-12-30T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 404
            }
        }
    },
    {
        "id": "77-N-White-Station-Rd,-Memphis,-TN-38117",
        "formattedAddress": "77 N White Station Rd, Memphis, TN 38117",
        "addressLine1": "77 N White Station Rd",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/2d6f7e3d8f79f8ba2aa23f5e82a27169-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38117",
        "county": "Shelby",
        "latitude": 35.133081,
        "longitude": -89.887678,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3,
        "lotSize": 14375,
        "yearBuilt": 1956,
        "status": "Active",
        "price": 339000,
        "listingType": "Standard",
        "listedDate": "2024-01-05T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-02-21T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:23:50.330Z",
        "daysOnMarket": 398,
        "mlsName": "Memphis",
        "mlsNumber": "10163502",
        "listingAgent": {
            "name": "Crystal Mitchell",
            "phone": "9017568900",
            "email": "crystal.mitchell@crye-leike.com"
        },
        "listingOffice": {
            "name": "Paradigm21 Realty",
            "phone": "9014992333",
            "email": "danbutler901@gmail.com"
        },
        "history": {
            "2024-01-05": {
                "event": "Sale Listing",
                "price": 339000,
                "listingType": "Standard",
                "listedDate": "2024-01-05T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 398
            }
        }
    },
    {
        "id": "3499-Mayfair-Ave,-Memphis,-TN-38122",
        "formattedAddress": "3499 Mayfair Ave, Memphis, TN 38122",
        "addressLine1": "3499 Mayfair Ave",
        "imgSrc":'https://photos.zillowstatic.com/fp/d2225f169dc093d5309a93b224e3cd12-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38122",
        "county": "Shelby",
        "latitude": 35.170639,
        "longitude": -89.94362,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 1,
        "lotSize": 10890,
        "yearBuilt": 1930,
        "status": "Active",
        "price": 124900,
        "listingType": "Standard",
        "listedDate": "2024-01-06T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-06T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:23:50.325Z",
        "daysOnMarket": 397,
        "mlsName": "Memphis",
        "mlsNumber": "10163598",
        "listingAgent": {
            "name": "Sandra Carranza",
            "phone": "9012214041",
            "email": "sandra.carranza@yahoo.com",
            "website": "http://kaizen-realty.com/"
        },
        "listingOffice": {
            "name": "KAIZEN Realty, LLC",
            "phone": "9012214041",
            "email": "sam@kaizen.ws",
            "website": "kaizen-realty.com"
        },
        "history": {
            "2024-01-06": {
                "event": "Sale Listing",
                "price": 124900,
                "listingType": "Standard",
                "listedDate": "2024-01-06T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 397
            }
        }
    },
    {
        "id": "3071-Ford-Rd,-Memphis,-TN-38109",
        "formattedAddress": "3071 Ford Rd, Memphis, TN 38109",
        "addressLine1": "3071 Ford Rd",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/e293146473a10ec896a78eb3cfa70911-cc_ft_768.webp',
  
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38109",
        "county": "Shelby",
        "latitude": 35.064981,
        "longitude": -90.081077,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "lotSize": 21344,
        "yearBuilt": 1940,
        "status": "Active",
        "price": 78333,
        "listingType": "Standard",
        "listedDate": "2024-02-19T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2020-12-09T09:37:58.789Z",
        "lastSeenDate": "2025-02-05T11:23:50.305Z",
        "daysOnMarket": 353,
        "mlsName": "Memphis",
        "mlsNumber": "10166190",
        "listingAgent": {
            "name": "Jo Mathes",
            "phone": "9014900092",
            "email": "angelictravel@yahoo.com",
            "website": "http://www.vintagehomes.com"
        },
        "listingOffice": {
            "name": "Pinnacle Realty",
            "phone": "9017077700",
            "email": "linmemphis1@gmail.com"
        },
        "history": {
            "2024-02-19": {
                "event": "Sale Listing",
                "price": 78333,
                "listingType": "Standard",
                "listedDate": "2024-02-19T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 353
            }
        }
    },
    {
        "id": "59-Devon-Way,-Memphis,-TN-38111",
        "formattedAddress": "59 Devon Way, Memphis, TN 38111",
        "imgSrc":'https://photos.zillowstatic.com/fp/60505b05ff512842fd2907084e9f73ff-cc_ft_768.webp',
        "addressLine1": "59 Devon Way",
        "addressLine2": null,
        "city": "Memphis",
        "state": "TN",
        "zipCode": "38111",
        "county": "Shelby",
        "latitude": 35.133214,
        "longitude": -89.930999,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3,
        "lotSize": 20038,
        "yearBuilt": 1950,
        "status": "Active",
        "price": 499000,
        "listingType": "Standard",
        "listedDate": "2024-03-07T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2021-02-23T14:16:57.928Z",
        "lastSeenDate": "2025-02-05T11:23:50.304Z",
        "daysOnMarket": 336,
        "mlsName": "Memphis",
        "mlsNumber": "10167355",
        "listingAgent": {
            "name": "Camille Zanone",
            "phone": "9017669004",
            "email": "camillezanone@zanonebuilders.com"
        },
        "listingOffice": {
            "name": "Crye-Leike, Inc., REALTORS",
            "phone": "9017669004",
            "email": "stevebrown@crye-leike.com"
        },
        "history": {
            "2024-03-07": {
                "event": "Sale Listing",
                "price": 499000,
                "listingType": "Standard",
                "listedDate": "2024-03-07T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 336
            }
        }
    },
   
   
  ]
  
  
  const currentListingsAugusta = [
    {
        "id": "692-Woodhall-Abbey-Ct,-Augusta,-GA-30907",
        "formattedAddress": "692 Woodhall Abbey Ct, Augusta, GA 30907",
        "addressLine1": "692 Woodhall Abbey Ct",
        "addressLine2": null,
        "city": "Augusta",
        "imgSrc":'https://photos.zillowstatic.com/fp/4e91bcdac15a85fc4cc5f3b3e7bab034-cc_ft_768.webp',
  
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.549584,
        "longitude": -82.076516,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3.5,
        "squareFootage": 2466,
        "lotSize": 6970,
        "yearBuilt": 1992,
        "status": "Active",
        "price": 439900,
        "listingType": "Standard",
        "listedDate": "2023-10-28T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-10-29T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:18:33.439Z",
        "daysOnMarket": 467,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "522068",
        "listingAgent": {
            "name": "Roman Waldera",
            "phone": "7068337259",
            "email": "roman@romanrealtyllc.com"
        },
        "listingOffice": {
            "name": "ROMAN REALTY, LLC",
            "phone": "7068337259"
        },
        "history": {
            "2023-10-28": {
                "event": "Sale Listing",
                "price": 439900,
                "listingType": "Standard",
                "listedDate": "2023-10-28T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 467
            }
        }
    },
    {
        "id": "4023-Danielle-Dr,-Augusta,-GA-30907",
        "formattedAddress": "4023 Danielle Dr, Augusta, GA 30907",
        "addressLine1": "4023 Danielle Dr",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/64a50340a4c4f13c1a90a3e19df241a8-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.527664,
        "longitude": -82.098717,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 1618,
        "lotSize": 14375,
        "yearBuilt": 1985,
        "status": "Active",
        "price": 285000,
        "listingType": "Standard",
        "listedDate": "2023-10-06T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-04-19T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:18:33.434Z",
        "daysOnMarket": 489,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "521345",
        "listingAgent": {
            "name": "Grant Sutton",
            "phone": "7067333375",
            "email": "grant30904@yahoo.com",
            "website": "http://www.grantsuttonsells.com"
        },
        "listingOffice": {
            "name": "Meybohm Real Estate-West Augusta",
            "phone": "7067363375",
            "email": "khogan@meybohm.com"
        },
        "history": {
            "2023-10-06": {
                "event": "Sale Listing",
                "price": 285000,
                "listingType": "Standard",
                "listedDate": "2023-10-06T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 489
            }
        }
    },
    {
        "id": "20-Winged-Foot-Dr,-Augusta,-GA-30907",
        "formattedAddress": "20 Winged Foot Dr, Augusta, GA 30907",
        "addressLine1": "20 Winged Foot Dr",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/c8d631a0230c79337f1b7002b279237c-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.544522,
        "longitude": -82.083484,
        "propertyType": "Single Family",
        "bedrooms": 6,
        "bathrooms": 7,
        "squareFootage": 7654,
        "lotSize": 59242,
        "yearBuilt": 2004,
        "status": "Active",
        "price": 1899000,
        "listingType": "Standard",
        "listedDate": "2024-07-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-07-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:18:15.834Z",
        "daysOnMarket": 213,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "531364",
        "listingAgent": {
            "name": "Roberta Sheehan",
            "phone": "7063731256",
            "email": "rsheehan@blanchardandcalhoun.com",
            "website": "http://www.robertasheehan.com"
        },
        "listingOffice": {
            "name": "Blanchard and Calhoun Real Estate ",
            "phone": "7068638953",
            "email": "kellison@blanchardandcalhoun.com",
            "website": "http://www.blanchardandcalhoun.com/"
        },
        "history": {
            "2024-07-08": {
                "event": "Sale Listing",
                "price": 1899000,
                "listingType": "Standard",
                "listedDate": "2024-07-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 213
            }
        }
    },
    {
        "id": "136-Shawns-Way,-Augusta,-GA-30907",
        "formattedAddress": "136 Shawns Way, Augusta, GA 30907",
        "addressLine1": "136 Shawns Way",
        "addressLine2": null,
        "city": "Augusta",
        "imgSrc":'https://photos.zillowstatic.com/fp/edc834c67f8def7271848e2fe7e0c9b1-cc_ft_768.webp',
  
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.511913,
        "longitude": -82.124816,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1130,
        "lotSize": 10019,
        "yearBuilt": 1981,
        "status": "Active",
        "price": 225000,
        "listingType": "Standard",
        "listedDate": "2024-08-29T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-08-29T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:18:15.794Z",
        "daysOnMarket": 161,
        "mlsName": "GeorgiaMLS",
        "mlsNumber": "10367129",
        "listingAgent": {
            "name": "Jade Wolfe",
            "phone": "7064261988",
            "email": "justcallwolfe@gmail.com",
            "website": "http://www.justcallwolfe.com"
        },
        "listingOffice": {
            "name": "Exp Realty LLC",
            "phone": "8889599461",
            "email": "jason.white@exprealty.com"
        },
        "history": {
            "2024-08-29": {
                "event": "Sale Listing",
                "price": 225000,
                "listingType": "Standard",
                "listedDate": "2024-08-29T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 161
            }
        }
    },
    {
        "id": "506-Stonebrook-Dr,-Augusta,-GA-30907",
        "formattedAddress": "506 Stonebrook Dr, Augusta, GA 30907",
        "addressLine1": "506 Stonebrook Dr",
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "imgSrc":'https://photos.zillowstatic.com/fp/1e414b4071e96ea8ea212bf7b5c6e57d-cc_ft_768.webp',
  
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.534879,
        "longitude": -82.058106,
        "propertyType": "Single Family",
        "bedrooms": 6,
        "bathrooms": 4.5,
        "squareFootage": 7167,
        "lotSize": 32234,
        "yearBuilt": 1999,
        "status": "Active",
        "price": 1300000,
        "listingType": "Standard",
        "listedDate": "2024-09-26T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-09-26T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:58:43.238Z",
        "daysOnMarket": 133,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "534425",
        "listingAgent": {
            "name": "Jackie Christensen",
            "phone": "7063647653",
            "email": "myrealtorjackiec@gmail.com"
        },
        "listingOffice": {
            "name": "Better Homes and Gardens Real Estate Executive Partners",
            "phone": "7063647653",
            "email": "broker@epaugusta.com",
            "website": "www.epaugusta.com"
        },
        "history": {
            "2024-09-26": {
                "event": "Sale Listing",
                "price": 1300000,
                "listingType": "Standard",
                "listedDate": "2024-09-26T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 133
            }
        }
    },
    {
        "id": "4324-Roswell-Dr,-Augusta,-GA-30907",
        "formattedAddress": "4324 Roswell Dr, Augusta, GA 30907",
        "addressLine1": "4324 Roswell Dr",
        "addressLine2": null,
        "city": "Augusta",
        "imgSrc":'https://photos.zillowstatic.com/fp/7df710754a7b006f028682de43aa8555-cc_ft_768.webp',
  
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.515884,
        "longitude": -82.12619,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1363,
        "lotSize": 23522,
        "yearBuilt": 1983,
        "status": "Active",
        "price": 254900,
        "listingType": "Standard",
        "listedDate": "2024-10-17T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-10-18T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:58:43.225Z",
        "daysOnMarket": 112,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "534711",
        "listingAgent": {
            "name": "Pamela Lightsey",
            "phone": "7068402087",
            "email": "pam@pamlightsey.com",
            "website": "http://www.pamlightsey.com/"
        },
        "listingOffice": {
            "name": "JIM COURSON REALTY",
            "phone": "7068603032",
            "email": "jim@coursonrealty.com",
            "website": "www.coursonrealty.com"
        },
        "history": {
            "2024-10-17": {
                "event": "Sale Listing",
                "price": 254900,
                "listingType": "Standard",
                "listedDate": "2024-10-17T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 112
            }
        }
    },
    {
        "id": "586-Firestone-Ct,-Augusta,-GA-30907",
        "formattedAddress": "586 Firestone Ct, Augusta, GA 30907",
        "addressLine1": "586 Firestone Ct",
        "addressLine2": null,
        "city": "Augusta",
        "imgSrc":'https://photos.zillowstatic.com/fp/41905377c0a910eafc5494bf6feec353-cc_ft_768.webp',
  
        "state": "GA",
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.537457,
        "longitude": -82.06651,
        "propertyType": "Single Family",
        "bedrooms": 6,
        "bathrooms": 5,
        "squareFootage": 5902,
        "lotSize": 48787,
        "yearBuilt": 2005,
        "status": "Active",
        "price": 1100000,
        "listingType": "Standard",
        "listedDate": "2024-11-27T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-11-28T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:58:43.188Z",
        "daysOnMarket": 71,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "536001",
        "listingAgent": {
            "name": "Pamela Weinberger",
            "email": "pweinberger@meybohm.com"
        },
        "listingOffice": {
            "name": "Meybohm Real Estate - Success Center",
            "phone": "7068638218",
            "email": "watersjanetwoods1@gmail.com"
        },
        "history": {
            "2024-11-27": {
                "event": "Sale Listing",
                "price": 1100000,
                "listingType": "Standard",
                "listedDate": "2024-11-27T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 71
            }
        }
    },
    {
        "id": "4171-Sigman-Dr,-Augusta,-GA-30907",
        "formattedAddress": "4171 Sigman Dr, Augusta, GA 30907",
        "addressLine1": "4171 Sigman Dr",
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "imgSrc":'https://photos.zillowstatic.com/fp/12e731d38528450fc0824d608bbffeb5-cc_ft_768.webp',
  
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.506246,
        "longitude": -82.109881,
        "propertyType": "Single Family",
        "bedrooms": 5,
        "bathrooms": 3.5,
        "squareFootage": 2763,
        "lotSize": 13068,
        "yearBuilt": 1983,
        "status": "Active",
        "price": 419900,
        "listingType": "Standard",
        "listedDate": "2024-11-14T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-11-15T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:58:43.169Z",
        "daysOnMarket": 84,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "535627",
        "listingAgent": {
            "name": "Brian Oneill",
            "phone": "7063065784",
            "email": "augustahomerelief@gmail.com"
        },
        "listingOffice": {
            "name": "HOME RELIEF, LLC",
            "phone": "7063065784",
            "email": "augustahomerelief@gmail.com"
        },
        "history": {
            "2024-11-14": {
                "event": "Sale Listing",
                "price": 419900,
                "listingType": "Standard",
                "listedDate": "2024-11-14T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 84
            }
        }
    },
    {
        "id": "4179-Wheeler-Rd,-Augusta,-GA-30907",
        "formattedAddress": "4179 Wheeler Rd, Augusta, GA 30907",
        "addressLine1": "4179 Wheeler Rd",
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "imgSrc":'https://maps.googleapis.com/maps/api/streetview?location=4179+Wheeler+Rd%2C+Augusta%2C+GA+30907&size=768x576&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=CZ-sHUHImzFpy9Bo7M1Bd4KGESw=',
  
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.489668,
        "longitude": -82.114888,
        "propertyType": "Single Family",
        "bedrooms": 7,
        "bathrooms": 3,
        "squareFootage": 4580,
        "lotSize": 108900,
        "yearBuilt": 1975,
        "status": "Active",
        "price": 399000,
        "listingType": "Standard",
        "listedDate": "2025-01-03T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2020-09-16T17:54:35.012Z",
        "lastSeenDate": "2025-02-05T10:57:27.153Z",
        "daysOnMarket": 34,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "533022",
        "listingAgent": {
            "name": "Joe Merritt",
            "phone": "7066274633",
            "email": "merrittrealtycompany@gmail.com"
        },
        "listingOffice": {
            "name": "MERRITT REALTY CO., LLC",
            "phone": "7066274633",
            "email": "joseph.merritt@yahoo.com"
        },
        "history": {
            "2025-01-03": {
                "event": "Sale Listing",
                "price": 399000,
                "listingType": "Standard",
                "listedDate": "2025-01-03T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 34
            }
        }
    },
    {
        "id": "4549-Colonial-Rd,-Augusta,-GA-30907",
        "formattedAddress": "4549 Colonial Rd, Augusta, GA 30907",
        "addressLine1": "4549 Colonial Rd",
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "imgSrc":'https://photos.zillowstatic.com/fp/016ab4fd3734a622565f21a8d512390c-cc_ft_768.webp',
  
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.490857,
        "longitude": -82.146785,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1363,
        "lotSize": 12632,
        "yearBuilt": 1977,
        "status": "Active",
        "price": 235000,
        "listingType": "Standard",
        "listedDate": "2025-01-27T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2025-01-28T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:52:06.806Z",
        "daysOnMarket": 10,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "537530",
        "listingAgent": {
            "name": "Micah Barber",
            "phone": "7629947750",
            "email": "mbarber@meybohm.com"
        },
        "listingOffice": {
            "name": "Meybohm Real Estate - Success Center",
            "phone": "7068638218",
            "email": "watersjanetwoods1@gmail.com"
        },
        "history": {
            "2025-01-27": {
                "event": "Sale Listing",
                "price": 235000,
                "listingType": "Standard",
                "listedDate": "2025-01-27T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 10
            }
        }
    },
    {
        "id": "209-Highview-Way,-Augusta,-GA-30907",
        "formattedAddress": "209 Highview Way, Augusta, GA 30907",
        "addressLine1": "209 Highview Way",
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "imgSrc":'https://photos.zillowstatic.com/fp/fd193bf931e9db64a3fe8079c61c7904-cc_ft_384.webp',
  
        "zipCode": "30907",
        "county": "Columbia",
        "latitude": 33.500835,
        "longitude": -82.14319,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1532,
        "lotSize": 14810,
        "yearBuilt": 1977,
        "status": "Active",
        "price": 239900,
        "listingType": "Standard",
        "listedDate": "2025-02-03T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2025-02-04T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:52:06.779Z",
        "daysOnMarket": 3,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "537856",
        "listingAgent": {
            "name": "Teresa Tiller",
            "phone": "7068334466",
            "email": "thetillergroup@gmail.com",
            "website": "http://www.teresatiller.remax-georgia.com"
        },
        "listingOffice": {
            "name": "RE MAX True Advantage",
            "phone": "7069229292",
            "email": "philipj@remax.net",
            "website": "www.remaxtrueadvantage.com"
        },
        "history": {
            "2025-02-03": {
                "event": "Sale Listing",
                "price": 239900,
                "listingType": "Standard",
                "listedDate": "2025-02-03T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 3
            }
        }
    },
    {
        "id": "2428-Faith-Trl,-Augusta,-GA-30906",
        "formattedAddress": "2428 Faith Trl, Augusta, GA 30906",
        "addressLine1": "2428 Faith Trl",
        "addressLine2": null,
        "city": "Augusta",
        "imgSrc":'https://photos.zillowstatic.com/fp/cfde5a41c96f007ff23961b0c8a5535c-cc_ft_768.webp',
  
        "state": "GA",
        "zipCode": "30906",
        "county": "Richmond",
        "latitude": 33.36475,
        "longitude": -82.041415,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 2024,
        "lotSize": 2614,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 222000,
        "listingType": "New Construction",
        "listedDate": "2024-03-17T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-03-17T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.222Z",
        "daysOnMarket": 326,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "526701",
        "listingAgent": {
            "name": "Cherelle Bonds",
            "phone": "7068631775",
            "email": "cherelleb.realtor@gmail.com"
        },
        "listingOffice": {
            "name": "Berkshire Hathaway HomeServices Beazley, REALTORS®",
            "phone": "7068631775",
            "email": "kjefferies@bhhsbeazleyrealtors.com",
            "website": "https://www.bhhsbeazleyrealtors.com"
        },
        "history": {
            "2024-03-17": {
                "event": "Sale Listing",
                "price": 222000,
                "listingType": "New Construction",
                "listedDate": "2024-03-17T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 326
            }
        }
    },
    {
        "id": "3106-Truxton-Rd,-Augusta,-GA-30906",
        "formattedAddress": "3106 Truxton Rd, Augusta, GA 30906",
        "addressLine1": "3106 Truxton Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/52c282849a73707d2f509a879aeadd68-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30906",
        "county": "Richmond",
        "latitude": 33.435887,
        "longitude": -82.053355,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1418,
        "lotSize": 18295,
        "yearBuilt": 1968,
        "status": "Active",
        "price": 179999,
        "listingType": "Standard",
        "listedDate": "2023-06-27T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-06-28T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.218Z",
        "daysOnMarket": 590,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "517333",
        "listingAgent": {
            "name": "Korey Schick",
            "phone": "7063997981",
            "email": "koreyschickrealestate@gmail.com",
            "website": "https://www.buyorsellaugustahomes.com/"
        },
        "listingOffice": {
            "name": "KELLER WILLIAMS REALTY AUGUSTA PARTNERS",
            "phone": "7068683772",
            "email": "regina.wadsworth@kw.com",
            "website": "http://www.kellerwilliamsaugusta.com"
        },
        "history": {
            "2023-06-27": {
                "event": "Sale Listing",
                "price": 179999,
                "listingType": "Standard",
                "listedDate": "2023-06-27T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 590
            }
        }
    },
    {
        "id": "1544-Ne-Chestnut-St,-Augusta,-GA-30901",
        "formattedAddress": "1544 Ne Chestnut St, Augusta, GA 30901",
        "addressLine1": "1544 Ne Chestnut St",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/476d0725574332f9b848823a209febe6-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30901",
        "county": "Richmond",
        "latitude": 33.458562,
        "longitude": -81.98396,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 1,
        "squareFootage": 1160,
        "lotSize": 3920,
        "yearBuilt": 1901,
        "status": "Active",
        "price": 34000,
        "listingType": "Standard",
        "listedDate": "2021-02-14T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-05-17T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.210Z",
        "daysOnMarket": 1453,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "465976",
        "listingAgent": {
            "name": "Mary Williams",
            "phone": "7067960106",
            "email": "ac21mwilliams@comcast.net",
            "website": "http://www.augustahomesmwilliams.com"
        },
        "listingOffice": {
            "name": "CENTURY 21 Jeff Keller Realty",
            "phone": "7067960106",
            "email": "custserv@century21jk.com",
            "website": "http://www.century21jk.com/"
        },
        "history": {
            "2021-02-14": {
                "event": "Sale Listing",
                "price": 34000,
                "listingType": "Standard",
                "listedDate": "2021-02-14T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 1453
            }
        }
    },
    {
        "id": "1623-Ne-Ramsey-St,-Augusta,-GA-30901",
        "formattedAddress": "1623 Ne Ramsey St, Augusta, GA 30901",
        "addressLine1": "1623 Ne Ramsey St",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/b46fedf6273f94c6ef125add34a611bd-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30901",
        "county": "Richmond",
        "latitude": 33.459166,
        "longitude": -81.995801,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "squareFootage": 1458,
        "lotSize": 4792,
        "yearBuilt": 1906,
        "status": "Active",
        "price": 40900,
        "listingType": "Standard",
        "listedDate": "2021-02-15T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-05-17T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.209Z",
        "daysOnMarket": 1452,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "465988",
        "listingAgent": {
            "name": "Mary Williams",
            "phone": "7067960106",
            "email": "ac21mwilliams@comcast.net",
            "website": "http://www.augustahomesmwilliams.com"
        },
        "listingOffice": {
            "name": "CENTURY 21 Jeff Keller Realty",
            "phone": "7067960106",
            "email": "custserv@century21jk.com",
            "website": "http://www.century21jk.com/"
        },
        "history": {
            "2021-02-15": {
                "event": "Sale Listing",
                "price": 40900,
                "listingType": "Standard",
                "listedDate": "2021-02-15T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 1452
            }
        }
    },
    {
        "id": "3004-Cedar-Hill-Ln,-Augusta,-GA-30909",
        "formattedAddress": "3004 Cedar Hill Ln, Augusta, GA 30909",
        "addressLine1": "3004 Cedar Hill Ln",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/32a4ac47259210732afbbd14c04ea676-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30909",
        "county": "Richmond",
        "latitude": 33.4817,
        "longitude": -82.071703,
        "propertyType": "Single Family",
        "bedrooms": 5,
        "bathrooms": 5.5,
        "squareFootage": 7643,
        "lotSize": 22651,
        "yearBuilt": 1999,
        "status": "Active",
        "price": 1276000,
        "listingType": "Standard",
        "listedDate": "2022-02-28T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-03-01T10:04:32.657Z",
        "lastSeenDate": "2025-02-05T08:58:12.206Z",
        "daysOnMarket": 1074,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "481707",
        "listingAgent": {
            "name": "Woody Trulock",
            "phone": "7068681000",
            "email": "wtrulock@blanchardandcalhoun.com"
        },
        "listingOffice": {
            "name": "Blanchard and Calhoun Real Estate",
            "phone": "7068681000",
            "email": "hsnider@blanchardandcalhoun.com",
            "website": "http://www.blanchardandcalhoun.com/"
        },
        "history": {
            "2022-02-28": {
                "event": "Sale Listing",
                "price": 1276000,
                "listingType": "Standard",
                "listedDate": "2022-02-28T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 1074
            }
        }
    },
    {
        "id": "2433-Faith-Trl,-Augusta,-GA-30906",
        "formattedAddress": "2433 Faith Trl, Augusta, GA 30906",
        "addressLine1": "2433 Faith Trl",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/ccb8c0f1ff4da97c70615cb6fddd0946-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30906",
        "county": "Richmond",
        "latitude": 33.36488,
        "longitude": -82.042014,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 1796,
        "lotSize": 3049,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 220000,
        "listingType": "New Construction",
        "listedDate": "2024-03-18T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-05-18T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.181Z",
        "daysOnMarket": 325,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "526730",
        "listingAgent": {
            "name": "Brian Jordan",
            "phone": "7068334180",
            "email": "mrjordanbj85@gmail.com"
        },
        "listingOffice": {
            "name": "BJORDAN REALTY, LLC",
            "phone": "7067500760"
        },
        "history": {
            "2024-03-18": {
                "event": "Sale Listing",
                "price": 220000,
                "listingType": "New Construction",
                "listedDate": "2024-03-18T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 325
            }
        }
    },
    {
        "id": "1240-Elbron-Dr,-Augusta,-GA-30909",
        "formattedAddress": "1240 Elbron Dr, Augusta, GA 30909",
        "addressLine1": "1240 Elbron Dr",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/8f6cfbb803fd1900cf749cae3a5519fa-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30909",
        "county": "Richmond",
        "latitude": 33.446445,
        "longitude": -82.155186,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 3.5,
        "squareFootage": 2779,
        "lotSize": 13068,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 467900,
        "listingType": "New Construction",
        "listedDate": "2024-05-01T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-05-02T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.172Z",
        "daysOnMarket": 281,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "528497",
        "listingAgent": {
            "name": "Rachel White",
            "phone": "7063999223",
            "email": "rwhite@bhhsbeazleyrealtors.com"
        },
        "listingOffice": {
            "name": "Berkshire Hathaway HomeServices Beazley, REALTORS®",
            "phone": "7068631775",
            "email": "kjefferies@bhhsbeazleyrealtors.com",
            "website": "https://www.bhhsbeazleyrealtors.com"
        },
        "history": {
            "2024-05-01": {
                "event": "Sale Listing",
                "price": 467900,
                "listingType": "New Construction",
                "listedDate": "2024-05-01T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 281
            }
        }
    },
    {
        "id": "2423-Faith-Trl,-Augusta,-GA-30906",
        "formattedAddress": "2423 Faith Trl, Augusta, GA 30906",
        "addressLine1": "2423 Faith Trl",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/787a3cc633be4f3a9e681df1e6b87f1a-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30906",
        "county": "Richmond",
        "latitude": 33.365154,
        "longitude": -82.041697,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 1796,
        "lotSize": 2614,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 215000,
        "listingType": "New Construction",
        "listedDate": "2024-03-17T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-03-17T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.167Z",
        "daysOnMarket": 326,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "526703",
        "listingAgent": {
            "name": "Cherelle Bonds",
            "phone": "7068631775",
            "email": "cherelleb.realtor@gmail.com"
        },
        "listingOffice": {
            "name": "Berkshire Hathaway HomeServices Beazley, REALTORS®",
            "phone": "7068631775",
            "email": "kjefferies@bhhsbeazleyrealtors.com",
            "website": "https://www.bhhsbeazleyrealtors.com"
        },
        "history": {
            "2024-03-17": {
                "event": "Sale Listing",
                "price": 215000,
                "listingType": "New Construction",
                "listedDate": "2024-03-17T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 326
            }
        }
    },
    {
        "id": "2429-Faith-Trl,-Augusta,-GA-30906",
        "formattedAddress": "2429 Faith Trl, Augusta, GA 30906",
        "addressLine1": "2429 Faith Trl",
        "addressLine2": null,
        "imgSrc":'https://photos.zillowstatic.com/fp/d05770ab9d440e19e1bf4676d230439f-cc_ft_768.webp',
  
        "city": "Augusta",
        "state": "GA",
        "zipCode": "30906",
        "county": "Richmond",
        "latitude": 33.364983,
        "longitude": -82.04187,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 1796,
        "lotSize": 2614,
        "yearBuilt": 2024,
        "status": "Active",
        "price": 217000,
        "listingType": "New Construction",
        "listedDate": "2024-03-17T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-03-18T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T08:58:12.164Z",
        "daysOnMarket": 326,
        "mlsName": "GreaterAugusta",
        "mlsNumber": "526720",
        "listingAgent": {
            "name": "Cherelle Bonds",
            "phone": "7068631775",
            "email": "cherelleb.realtor@gmail.com"
        },
        "listingOffice": {
            "name": "Berkshire Hathaway HomeServices Beazley, REALTORS®",
            "phone": "7068631775",
            "email": "kjefferies@bhhsbeazleyrealtors.com",
            "website": "https://www.bhhsbeazleyrealtors.com"
        },
        "history": {
            "2024-03-17": {
                "event": "Sale Listing",
                "price": 217000,
                "listingType": "New Construction",
                "listedDate": "2024-03-17T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 326
            }
        }
    }
  ]
  
  const currentListingsBirmingham = [
    {
        "id": "124-Kappa-Ave-S,-Birmingham,-AL-35205",
        "formattedAddress": "124 Kappa Ave S, Birmingham, AL 35205",
        "addressLine1": "124 Kappa Ave S",
        "imgSrc":'https://photos.zillowstatic.com/fp/5b7143aa70a011ba8b40f98e531f68df-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35205",
        "county": "Jefferson",
        "latitude": 33.499635,
        "longitude": -86.829768,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "squareFootage": 728,
        "lotSize": 3049,
        "yearBuilt": 1930,
        "status": "Active",
        "price": 45000,
        "listingType": "Standard",
        "listedDate": "2023-04-23T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-04-24T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:55:10.632Z",
        "daysOnMarket": 655,
        "mlsName": "Birmingham",
        "mlsNumber": "1351924",
        "listingAgent": {
            "name": "Johnny Parnell",
            "phone": "2057465631",
            "email": "johnnieparnell@gmail.com"
        },
        "listingOffice": {
            "name": "All Access Real Estate",
            "phone": "2059797004",
            "email": "johnnieparnell@gmail.com"
        },
        "history": {
            "2023-04-23": {
                "event": "Sale Listing",
                "price": 45000,
                "listingType": "Standard",
                "listedDate": "2023-04-23T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 655
            }
        }
    },
    {
        "id": "1324-22nd-St-N,-Birmingham,-AL-35234",
        "formattedAddress": "1324 22nd St N, Birmingham, AL 35234",
        "addressLine1": "1324 22nd St N",
        "imgSrc":'https://photos.zillowstatic.com/fp/7370c80044c8ca9659340997de10d0f3-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35234",
        "county": "Jefferson",
        "latitude": 33.530521,
        "longitude": -86.813233,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "squareFootage": 1268,
        "lotSize": 6970,
        "yearBuilt": 1920,
        "status": "Active",
        "price": 80000,
        "listingType": "Standard",
        "listedDate": "2023-05-22T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-05-23T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:55:10.630Z",
        "daysOnMarket": 626,
        "mlsName": "Birmingham",
        "mlsNumber": "1354718",
        "listingAgent": {
            "name": "Justin C. Williams",
            "phone": "2059454663",
            "email": "justin@townsquare4ahome.com",
            "website": "http://www.townsquare4ahome.com"
        },
        "listingOffice": {
            "name": "Keller Williams Realty Vestavia",
            "phone": "2053976500",
            "email": "rickhoneycutt@bellsouth.net"
        },
        "history": {
            "2023-05-22": {
                "event": "Sale Listing",
                "price": 80000,
                "listingType": "Standard",
                "listedDate": "2023-05-22T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 626
            }
        }
    },
    {
        "id": "8415-4th-Ave-N,-Birmingham,-AL-35206",
        "formattedAddress": "8415 4th Ave N, Birmingham, AL 35206",
        "addressLine1": "8415 4th Ave N",
        "imgSrc":'https://photos.zillowstatic.com/fp/8c1763d7690339f75b5ecc481f2b4546-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35206",
        "county": "Jefferson",
        "latitude": 33.575073,
        "longitude": -86.725073,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 2,
        "squareFootage": 1312,
        "lotSize": 10019,
        "yearBuilt": 1949,
        "status": "Active",
        "price": 84000,
        "listingType": "Standard",
        "listedDate": "2023-02-23T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-02-24T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:55:10.628Z",
        "daysOnMarket": 714,
        "mlsName": "Birmingham",
        "mlsNumber": "1346440",
        "listingAgent": {
            "name": "Shayla Dotson",
            "phone": "2052251239",
            "email": "shayla@1stclassrealtyservices.com",
            "website": "www.1stclassrealtyservices.com"
        },
        "listingOffice": {
            "name": "First Class Realty Services, LLC",
            "phone": "2052251239"
        },
        "history": {
            "2023-02-23": {
                "event": "Sale Listing",
                "price": 84000,
                "listingType": "Standard",
                "listedDate": "2023-02-23T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 714
            },
            "2023-01-23": {
                "event": "Sale Listing",
                "price": 88000,
                "listingType": "Standard",
                "listedDate": "2023-02-23T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 714
            },
            
        }
    },
    {
        "id": "4533-Winchester-Hills-Way,-Birmingham,-AL-35215",
        "formattedAddress": "4533 Winchester Hills Way, Birmingham, AL 35215",
        "addressLine1": "4533 Winchester Hills Way",
        "imgSrc":'https://photos.zillowstatic.com/fp/592984ea12dfe595515cc66d95aa0e43-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35215",
        "county": "Jefferson",
        "latitude": 33.662977,
        "longitude": -86.657681,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "yearBuilt": 2020,
        "status": "Active",
        "price": 210319,
        "listingType": "Standard",
        "listedDate": "2023-07-25T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-07-26T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:52:14.617Z",
        "daysOnMarket": 562,
        "mlsName": "MyStateMLS",
        "mlsNumber": "11193679",
        "listingAgent": {
            "name": "Emerson Jerry King",
            "phone": "8008018003",
            "email": "king632@bellsouth.net"
        },
        "listingOffice": {
            "name": "Williams & Williams Real Estate Auctions",
            "phone": "8008018003"
        },
        "history": {
            "2023-07-25": {
                "event": "Sale Listing",
                "price": 210319,
                "listingType": "Standard",
                "listedDate": "2023-07-25T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 562
            },
            "2023-07-25": {
                "event": "Sale Listing",
                "price": 250239,
                "listingType": "Standard",
                "listedDate": "2023-07-25T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 562
            }
        }
    },
    {
        "id": "3408-Sw-Laurel-Ave,-Birmingham,-AL-35221",
        "formattedAddress": "3408 Sw Laurel Ave, Birmingham, AL 35221",
        "addressLine1": "3408 Sw Laurel Ave",
        "imgSrc":'https://photos.zillowstatic.com/fp/d274428711d0164b8643c73fc6f00543-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35221",
        "county": "Jefferson",
        "latitude": 33.455274,
        "longitude": -86.889169,
        "propertyType": "Single Family",
        "bedrooms": 1,
        "bathrooms": 1,
        "squareFootage": 768,
        "lotSize": 6098,
        "yearBuilt": 1930,
        "status": "Active",
        "price": 77900,
        "listingType": "Standard",
        "listedDate": "2023-08-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2021-06-19T10:10:12.265Z",
        "lastSeenDate": "2025-02-05T11:52:14.615Z",
        "daysOnMarket": 548,
        "mlsName": "Birmingham",
        "mlsNumber": "1362126",
        "listingAgent": {
            "name": "Sherry Le",
            "phone": "2562251463",
            "email": "sherryle@kw.com"
        },
        "listingOffice": {
            "name": "Keller Williams Realty Hoover",
            "phone": "2058222272",
            "email": "jdurban@kw.com",
            "website": "www.kellerwilliamshoover.com"
        },
        "history": {
            "2023-08-08": {
                "event": "Sale Listing",
                "price": 77900,
                "listingType": "Standard",
                "listedDate": "2023-08-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 548
            }
        }
    },
    {
        "id": "1930-Center-St-S,-Birmingham,-AL-35205",
        "formattedAddress": "1930 Center St S, Birmingham, AL 35205",
        "addressLine1": "1930 Center St S",
        "imgSrc": [
          "https://photos.zillowstatic.com/fp/d274428711d0164b8643c73fc6f00543-cc_ft_768.webp",
          "https://photos.zillowstatic.com/fp/another-image-url.webp",
          "https://photos.zillowstatic.com/fp/yet-another-image-url.webp"
        ],
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35205",
        "county": "Jefferson",
        "latitude": 33.485489,
        "longitude": -86.831173,
        "propertyType": "Single Family",
        "bedrooms": 8,
        "bathrooms": 4.5,
        "squareFootage": 6645,
        "lotSize": 17860,
        "yearBuilt": 1920,
        "status": "Active",
        "price": 265000,
        "listingType": "Standard",
        "listedDate": "2023-12-13T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2021-05-12T14:31:03.646Z",
        "lastSeenDate": "2025-02-05T11:52:14.593Z",
        "daysOnMarket": 421,
        "mlsName": "Birmingham",
        "mlsNumber": "21372635",
        "listingAgent": {
            "name": "Johnny Parnell",
            "phone": "2057465631",
            "email": "johnnieparnell@gmail.com"
        },
        "listingOffice": {
            "name": "All Access Real Estate",
            "phone": "2059797004",
            "email": "johnnieparnell@gmail.com"
        },
        "history": {
            "2023-12-13": {
                "event": "Sale Listing",
                "price": 265000,
                "listingType": "Standard",
                "listedDate": "2023-12-13T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 421
            }
        }
    },
    {
        "id": "4826-Leola-Ln,-Birmingham,-AL-35207",
        "formattedAddress": "4826 Leola Ln, Birmingham, AL 35207",
        "addressLine1": "4826 Leola Ln",
        "imgSrc":'https://photos.zillowstatic.com/fp/c461d9627e8fc11671a73ed7862ca3c1-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35207",
        "county": "Jefferson",
        "latitude": 33.578424,
        "longitude": -86.829034,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 1820,
        "lotSize": 10106,
        "yearBuilt": 1988,
        "status": "Active",
        "price": 115000,
        "listingType": "Standard",
        "listedDate": "2023-12-22T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-23T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:52:14.588Z",
        "daysOnMarket": 412,
        "mlsName": "Birmingham",
        "mlsNumber": "21373142",
        "listingAgent": {
            "name": "Tesa Brown",
            "phone": "2059789000",
            "email": "tbrown@realtysouth.com",
            "website": "https://tesabrown.realtysouth.com/"
        },
        "listingOffice": {
            "name": "RealtySouth | OTM Acton Rd.",
            "phone": "8778900050",
            "email": "customercare@realtysouth.com",
            "website": "www.realtysouth.com"
        },
        "history": {
            "2023-12-22": {
                "event": "Sale Listing",
                "price": 115000,
                "listingType": "Standard",
                "listedDate": "2023-12-22T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 412
            }
        }
    },
    {
        "id": "6481-Old-Springville-Rd,-Birmingham,-AL-35126",
        "formattedAddress": "6481 Old Springville Rd, Birmingham, AL 35126",
        "addressLine1": "6481 Old Springville Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/e5bb70dcf750d2d23d137ad986a41754-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35126",
        "county": "Jefferson",
        "latitude": 33.691352,
        "longitude": -86.61619,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 3,
        "squareFootage": 2616,
        "lotSize": 871200,
        "yearBuilt": 1975,
        "status": "Active",
        "price": 299000,
        "listingType": "Standard",
        "listedDate": "2024-03-06T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-03-07T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:52:14.584Z",
        "daysOnMarket": 337,
        "mlsName": "Birmingham",
        "mlsNumber": "21378915",
        "listingAgent": {
            "name": "Billy Valekis",
            "phone": "2052435744",
            "email": "bvalekis@arcrealtyco.com"
        },
        "listingOffice": {
            "name": "ARC Realty Cahaba Heights",
            "phone": "2059698910",
            "email": "tbittner@arcrealtyco.com"
        },
        "history": {
            "2024-03-06": {
                "event": "Sale Listing",
                "price": 299000,
                "listingType": "Standard",
                "listedDate": "2024-03-06T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 337
            }
        }
    },
    {
        "id": "413-Lance-Ln,-Birmingham,-AL-35206",
        "formattedAddress": "413 Lance Ln, Birmingham, AL 35206",
        "addressLine1": "413 Lance Ln",
        "imgSrc":'https://photos.zillowstatic.com/fp/df475354a14a0de0016a7ea15f0520e1-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35206",
        "county": "Jefferson",
        "latitude": 33.5732,
        "longitude": -86.692747,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1329,
        "lotSize": 16117,
        "yearBuilt": 1973,
        "status": "Active",
        "price": 184900,
        "listingType": "Standard",
        "listedDate": "2024-02-29T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-03-01T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:52:14.580Z",
        "daysOnMarket": 343,
        "mlsName": "Birmingham",
        "mlsNumber": "21378347",
        "listingAgent": {
            "name": "Kelley Shaw Smith",
            "phone": "2059034975",
            "email": "kelleyshawsmith@hotmail.com",
            "website": "http://www.kelleyshawsmith.com"
        },
        "listingOffice": {
            "name": "RE/MAX on Main",
            "phone": "2051234567"
        },
        "history": {
            "2024-02-29": {
                "event": "Sale Listing",
                "price": 184900,
                "listingType": "Standard",
                "listedDate": "2024-02-29T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 343
            }
        }
    },
    {
        "id": "4973-Kerri-Ln,-Birmingham,-AL-35215",
        "formattedAddress": "4973 Kerri Ln, Birmingham, AL 35215",
        "addressLine1": "4973 Kerri Ln",
        "imgSrc":'https://photos.zillowstatic.com/fp/1a34a4010d255ee366795f7405c3ef49-cc_ft_1536.webp',
  
        "addressLine2": null,
        "city": "Birmingham",
        "state": "AL",
        "zipCode": "35215",
        "county": "Jefferson",
        "latitude": 33.656105,
        "longitude": -86.657569,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1484,
        "yearBuilt": 2024,
        "hoa": {
            "fee": 7
        },
        "status": "Active",
        "price": 259900,
        "listingType": "New Construction",
        "listedDate": "2024-01-25T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-26T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:52:14.579Z",
        "daysOnMarket": 378,
        "mlsName": "Birmingham",
        "mlsNumber": "21375289",
        "listingAgent": {
            "name": "George Holman",
            "phone": "2052229892",
            "email": "george@energysmartnewhomes.com"
        },
        "listingOffice": {
            "name": "Energy Smart New Homes, Llc",
            "phone": "2052229892",
            "email": "ghholman@aol.com"
        },
        "history": {
            "2024-01-25": {
                "event": "Sale Listing",
                "price": 259900,
                "listingType": "New Construction",
                "listedDate": "2024-01-25T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 378
            }
        }
    }
  ]
  
  const currentListingsLittleRock = [
    {
        "id": "3-Rose-Meadow-Pl,-Little-Rock,-AR-72206",
        "formattedAddress": "3 Rose Meadow Pl, Little Rock, AR 72206",
        "addressLine1": "3 Rose Meadow Pl",
        "imgSrc":'https://photos.zillowstatic.com/fp/dac0140be6de0a987a06ba654114b42b-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72206",
        "county": "Pulaski",
        "latitude": 34.721675,
        "longitude": -92.210967,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1496,
        "lotSize": 8712,
        "yearBuilt": 1962,
        "status": "Active",
        "price": 90000,
        "listingType": "Standard",
        "listedDate": "2023-08-26T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-08-27T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:32:08.259Z",
        "daysOnMarket": 530,
        "mlsName": "Carmls",
        "mlsNumber": "23026870",
        "listingAgent": {
            "name": "Shirley Whitfield",
            "phone": "5018913779",
            "email": "annwhitfield91@gmail.com"
        },
        "listingOffice": {
            "name": "McKimmey Realtors-NLR",
            "phone": "5018123500",
            "email": "hayley@mckimmey.com",
            "website": "http://www.mckimmey.com/"
        },
        "history": {
            "2023-08-26": {
                "event": "Sale Listing",
                "price": 90000,
                "listingType": "Standard",
                "listedDate": "2023-08-26T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 530
            }
        }
    },
    {
        "id": "27-Barbara-Dr,-Little-Rock,-AR-72204",
        "formattedAddress": "27 Barbara Dr, Little Rock, AR 72204",
        "addressLine1": "27 Barbara Dr",
        "imgSrc":'https://maps.googleapis.com/maps/api/streetview?location=27+Barbara+Dr%2C+Little+Rock%2C+AR+72204&size=768x576&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=Vk2E-I8ywXL96LPxSHWovvrdyJ4=',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72204",
        "county": "Pulaski",
        "latitude": 34.73341,
        "longitude": -92.346978,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "squareFootage": 1090,
        "lotSize": 8276,
        "yearBuilt": 1954,
        "status": "Active",
        "price": 110000,
        "listingType": "Standard",
        "listedDate": "2023-12-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-01-25T07:51:28.623Z",
        "lastSeenDate": "2025-02-05T11:28:24.799Z",
        "daysOnMarket": 426,
        "mlsName": "Carmls",
        "mlsNumber": "23039268",
        "listingAgent": {
            "name": "Katrina Yarboro",
            "phone": "5018432003",
            "email": "klyarboro@gmail.com"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2023-12-08": {
                "event": "Sale Listing",
                "price": 110000,
                "listingType": "Standard",
                "listedDate": "2023-12-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 426
            }
        }
    },
    {
        "id": "4407-Bowers-St,-Little-Rock,-AR-72204",
        "formattedAddress": "4407 Bowers St, Little Rock, AR 72204",
        "addressLine1": "4407 Bowers St",
        "imgSrc":'https://photos.zillowstatic.com/fp/a5eeaef8747edd309db9493874bb63aa-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72204",
        "county": "Pulaski",
        "latitude": 34.713149,
        "longitude": -92.378421,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1243,
        "lotSize": 7405,
        "yearBuilt": 2023,
        "status": "Active",
        "price": 180000,
        "listingType": "New Construction",
        "listedDate": "2023-12-04T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-06-04T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.796Z",
        "daysOnMarket": 430,
        "mlsName": "Carmls",
        "mlsNumber": "23038727",
        "listingAgent": {
            "name": "Arthur Abston",
            "phone": "5012870706",
            "email": "adabston@kw.com"
        },
        "listingOffice": {
            "name": "Keller Williams Realty Lr Branch",
            "phone": "5019075959",
            "email": "karlfreeman@kw.com"
        },
        "history": {
            "2023-12-04": {
                "event": "Sale Listing",
                "price": 180000,
                "listingType": "New Construction",
                "listedDate": "2023-12-04T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 430
            }
        }
    },
    {
        "id": "1401-S-Harrison-St,-Little-Rock,-AR-72204",
        "formattedAddress": "1401 S Harrison St, Little Rock, AR 72204",
        "addressLine1": "1401 S Harrison St",
        "imgSrc":'https://maps.googleapis.com/maps/api/streetview?location=1401+S+Harrison+St%2C+Little+Rock%2C+AR+72204&size=768x576&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=Gji_YmB_2g5-PA19NpedFnzJpwk=',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72204",
        "county": "Pulaski",
        "latitude": 34.739106,
        "longitude": -92.332007,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "squareFootage": 921,
        "lotSize": 6534,
        "yearBuilt": 1945,
        "status": "Active",
        "price": 80000,
        "listingType": "Standard",
        "listedDate": "2023-12-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.796Z",
        "daysOnMarket": 426,
        "mlsName": "Carmls",
        "mlsNumber": "23039251",
        "listingAgent": {
            "name": "Katrina Yarboro",
            "phone": "5018432003",
            "email": "klyarboro@gmail.com"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2023-12-08": {
                "event": "Sale Listing",
                "price": 80000,
                "listingType": "Standard",
                "listedDate": "2023-12-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 426
            }
        }
    },
    {
        "id": "5210-Park-Village-Dr,-Little-Rock,-AR-72209",
        "formattedAddress": "5210 Park Village Dr, Little Rock, AR 72209",
        "addressLine1": "5210 Park Village Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/5b92227b62bc26516a64c713c15418e0-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72209",
        "county": "Pulaski",
        "latitude": 34.682894,
        "longitude": -92.335018,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1392,
        "lotSize": 7841,
        "yearBuilt": 1972,
        "status": "Active",
        "price": 115000,
        "listingType": "Standard",
        "listedDate": "2023-12-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.793Z",
        "daysOnMarket": 426,
        "mlsName": "Carmls",
        "mlsNumber": "23039275",
        "listingAgent": {
            "name": "Katrina Yarboro",
            "phone": "5018432003",
            "email": "klyarboro@gmail.com"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2023-12-08": {
                "event": "Sale Listing",
                "price": 115000,
                "listingType": "Standard",
                "listedDate": "2023-12-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 426
            }
        }
    },
    {
        "id": "6101-Ridgecrest-Dr,-Little-Rock,-AR-72205",
        "formattedAddress": "6101 Ridgecrest Dr, Little Rock, AR 72205",
        "addressLine1": "6101 Ridgecrest Dr",
        "imgSrc":'https://photos.zillowstatic.com/fp/f013d0670d0d1fa0b19b7c7c4ac2fb7a-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72205",
        "county": "Pulaski",
        "latitude": 34.757915,
        "longitude": -92.341262,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1496,
        "lotSize": 8276,
        "yearBuilt": 1957,
        "status": "Active",
        "price": 220000,
        "listingType": "Standard",
        "listedDate": "2023-12-12T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.791Z",
        "daysOnMarket": 422,
        "mlsName": "Carmls",
        "mlsNumber": "23039550",
        "listingAgent": {
            "name": "Katrina Yarboro",
            "phone": "5018432003",
            "email": "klyarboro@gmail.com"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2023-12-12": {
                "event": "Sale Listing",
                "price": 220000,
                "listingType": "Standard",
                "listedDate": "2023-12-12T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 422
            }
        }
    },
    {
        "id": "1811-Peyton-St,-Little-Rock,-AR-72204",
        "formattedAddress": "1811 Peyton St, Little Rock, AR 72204",
        "addressLine1": "1811 Peyton St",
        "imgSrc":'https://maps.googleapis.com/maps/api/streetview?location=1811+Peyton+St%2C+Little+Rock%2C+AR+72204&size=768x576&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=eHd5C0hWVdupJtW2rnpDISKQnhY=',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72204",
        "county": "Pulaski",
        "latitude": 34.73435,
        "longitude": -92.32252,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 2194,
        "lotSize": 4792,
        "yearBuilt": 1950,
        "status": "Active",
        "price": 140000,
        "listingType": "Standard",
        "listedDate": "2023-12-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.786Z",
        "daysOnMarket": 426,
        "mlsName": "Carmls",
        "mlsNumber": "23039255",
        "listingAgent": {
            "name": "Katrina Yarboro",
            "phone": "5018432003",
            "email": "klyarboro@gmail.com"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2023-12-08": {
                "event": "Sale Listing",
                "price": 140000,
                "listingType": "Standard",
                "listedDate": "2023-12-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 426
            }
        }
    },
    {
        "id": "6100-Fourche-Dam-Pike,-Little-Rock,-AR-72206",
        "formattedAddress": "6100 Fourche Dam Pike, Little Rock, AR 72206",
        "addressLine1": "6100 Fourche Dam Pike",
        "imgSrc":'https://photos.zillowstatic.com/fp/be9096df118a13c5b9ee890cfd095018-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72206",
        "county": "Pulaski",
        "latitude": 34.724908,
        "longitude": -92.200636,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1,
        "squareFootage": 1056,
        "lotSize": 27007,
        "yearBuilt": 1930,
        "status": "Active",
        "price": 70000,
        "listingType": "Standard",
        "listedDate": "2023-09-08T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-09-09T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.749Z",
        "daysOnMarket": 517,
        "mlsName": "Carmls",
        "mlsNumber": "23028286",
        "listingAgent": {
            "name": "Shirley Whitfield",
            "phone": "5018913779",
            "email": "annwhitfield91@gmail.com"
        },
        "listingOffice": {
            "name": "McKimmey Realtors-NLR",
            "phone": "5018123500",
            "email": "hayley@mckimmey.com",
            "website": "http://www.mckimmey.com/"
        },
        "history": {
            "2023-09-08": {
                "event": "Sale Listing",
                "price": 70000,
                "listingType": "Standard",
                "listedDate": "2023-09-08T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 517
            }
        }
    },
    {
        "id": "2222-N-University-Ave,-Little-Rock,-AR-72207",
        "formattedAddress": "2222 N University Ave, Little Rock, AR 72207",
        "addressLine1": "2222 N University Ave",
        "imgSrc":'https://photos.zillowstatic.com/fp/2425ab85429957c6cf772aab6cdf0f1e-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72207",
        "county": "Pulaski",
        "latitude": 34.772984,
        "longitude": -92.340818,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 3,
        "squareFootage": 2284,
        "lotSize": 6970,
        "yearBuilt": 1925,
        "status": "Active",
        "price": 449000,
        "listingType": "Standard",
        "listedDate": "2024-02-21T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-06-10T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.719Z",
        "daysOnMarket": 351,
        "mlsName": "Carmls",
        "mlsNumber": "24005736",
        "listingAgent": {
            "name": "Susan Reynolds",
            "phone": "5012243201",
            "email": "susan@janetjones.com",
            "website": "http://www.janetjones.com"
        },
        "listingOffice": {
            "name": "THE JANET JONES COMPANY REALTORS",
            "phone": "5012243201",
            "email": "brock@janetjones.com",
            "website": "http://www.janetjones.com"
        },
        "history": {
            "2024-02-21": {
                "event": "Sale Listing",
                "price": 449000,
                "listingType": "Standard",
                "listedDate": "2024-02-21T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 351
            }
        }
    },
    {
        "id": "1913-Allis-St,-Little-Rock,-AR-72204",
        "formattedAddress": "1913 Allis St, Little Rock, AR 72204",
        "addressLine1": "1913 Allis St",
        "addressLine2": null,
        "imgSrc":'https://maps.googleapis.com/maps/api/streetview?location=1913+Allis+St%2C+Little+Rock%2C+AR+72204&size=768x576&key=AIzaSyARFMLB1na-BBWf7_R3-5YOQQaHqEJf6RQ&source=outdoor&&signature=CtYl8F-tMjTdc4F0CgO0_7kHIH8=',
  
        "city": "Little Rock",
        "state": "AR",
        "zipCode": "72204",
        "county": "Pulaski",
        "latitude": 34.733389,
        "longitude": -92.309074,
        "propertyType": "Single Family",
        "bedrooms": 2,
        "bathrooms": 1,
        "squareFootage": 1064,
        "lotSize": 6970,
        "yearBuilt": 1955,
        "status": "Active",
        "price": 60000,
        "listingType": "Standard",
        "listedDate": "2024-01-24T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-02-10T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T11:28:24.712Z",
        "daysOnMarket": 379,
        "mlsName": "Carmls",
        "mlsNumber": "24002346",
        "listingAgent": {
            "name": "Mischelle Cullum",
            "phone": "5018311382",
            "email": "mischelle@centurytel.net"
        },
        "listingOffice": {
            "name": "Rgb Appraisals & Realty",
            "phone": "5018432003",
            "email": "rgbappraisals@classicnet.net"
        },
        "history": {
            "2024-01-24": {
                "event": "Sale Listing",
                "price": 60000,
                "listingType": "Standard",
                "listedDate": "2024-01-24T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 379
            }
        }
    }
  ]
  const currentListingsFortWayne = [
    {
        "id": "1737-Muruntau-Grv,-Fort-Wayne,-IN-46845",
        "formattedAddress": "1737 Muruntau Grv, Fort Wayne, IN 46845",
        "addressLine1": "1737 Muruntau Grv",
        "imgSrc":'https://photos.zillowstatic.com/fp/fbf03907dac4de0349e34a442a97f277-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46845",
        "county": "Allen",
        "latitude": 41.211301,
        "longitude": -85.165653,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1700,
        "lotSize": 8886,
        "yearBuilt": 2023,
        "hoa": {
            "fee": 46
        },
        "status": "Active",
        "price": 349900,
        "listingType": "New Construction",
        "listedDate": "2024-01-03T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-11-08T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:59:40.428Z",
        "daysOnMarket": 400,
        "mlsName": "IRMLS",
        "mlsNumber": "202400294",
        "listingAgent": {
            "name": "Courtney Ousley",
            "phone": "2604384209",
            "email": "courtney@northeasterngrouprealty.com",
            "website": "http://www.northeasternindianahomes.com"
        },
        "listingOffice": {
            "name": "North Eastern Group Realty",
            "phone": "2604897095",
            "email": "kim@northeasterngroup.com",
            "website": "http://www.northeasterngroup.com/"
        },
        "history": {
            "2024-01-03": {
                "event": "Sale Listing",
                "price": 349900,
                "listingType": "New Construction",
                "listedDate": "2024-01-03T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 400
            }
        }
    },
    {
        "id": "821-S-Scott-Rd,-Fort-Wayne,-IN-46814",
        "formattedAddress": "821 S Scott Rd, Fort Wayne, IN 46814",
        "addressLine1": "821 S Scott Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/9b239c49598be71569598074107cdff8-cc_ft_384.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46814",
        "county": "Allen",
        "latitude": 41.076419,
        "longitude": -85.273663,
        "propertyType": "Single Family",
        "bedrooms": 7,
        "bathrooms": 8,
        "squareFootage": 11089,
        "lotSize": 410771,
        "yearBuilt": 1976,
        "status": "Active",
        "price": 1499900,
        "listingType": "Standard",
        "listedDate": "2022-10-28T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-10-28T10:28:30.469Z",
        "lastSeenDate": "2025-02-05T10:59:40.427Z",
        "daysOnMarket": 832,
        "mlsName": "IRMLS",
        "mlsNumber": "202244613",
        "listingAgent": {
            "name": "Aj Sheehe",
            "phone": "2603991177",
            "email": "ajsheehe@gmail.com"
        },
        "listingOffice": {
            "name": "CENTURY 21 Bradley Realty, Inc.",
            "phone": "2603991177",
            "email": "leadership@c21bradley.com",
            "website": "http://century21bradley.com/"
        },
        "history": {
            "2022-10-28": {
                "event": "Sale Listing",
                "price": 1499900,
                "listingType": "Standard",
                "listedDate": "2022-10-28T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 832
            }
        }
    },
    {
        "id": "4945-Cultivator-Ct,-Fort-Wayne,-IN-46818",
        "formattedAddress": "4945 Cultivator Ct, Fort Wayne, IN 46818",
        "addressLine1": "4945 Cultivator Ct",
        "imgSrc":'https://photos.zillowstatic.com/fp/645e2ce07624b4f71d3aeef3b7720402-cc_ft_768.webp' ,
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46818",
        "county": "Allen",
        "latitude": 41.194511,
        "longitude": -85.207512,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1622,
        "lotSize": 9761,
        "yearBuilt": 2023,
        "status": "Active",
        "price": 319900,
        "listingType": "Standard",
        "listedDate": "2023-12-07T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-12-08T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:59:40.425Z",
        "daysOnMarket": 427,
        "mlsName": "IRMLS",
        "mlsNumber": "202344025",
        "listingAgent": {
            "name": "Michael Mckinney",
            "phone": "2604892000",
            "email": "mpm3211@gmail.com"
        },
        "listingOffice": {
            "name": "Mike Thomas Associates",
            "phone": "2604892000",
            "email": "info@mikethomasrealtor.com",
            "website": "www.mikethomasrealtor.com"
        },
        "history": {
            "2023-12-07": {
                "event": "Sale Listing",
                "price": 319900,
                "listingType": "Standard",
                "listedDate": "2023-12-07T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 427
            }
        }
    },
    {
        "id": "3842-Shadowood-Lakes-Trl,-Fort-Wayne,-IN-46818",
        "formattedAddress": "3842 Shadowood Lakes Trl, Fort Wayne, IN 46818",
        "addressLine1": "3842 Shadowood Lakes Trl",
        "imgSrc":'https://photos.zillowstatic.com/fp/3c43ede45d453e8929ecd6fb0dc3cc65-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46818",
        "county": "Allen",
        "latitude": 41.156804394,
        "longitude": -85.19568107,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 2.5,
        "squareFootage": 2264,
        "lotSize": 8799,
        "yearBuilt": 2024,
        "hoa": {
            "fee": 42
        },
        "status": "Active",
        "price": 356936,
        "listingType": "New Construction",
        "listedDate": "2024-02-06T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-02-07T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:59:40.412Z",
        "daysOnMarket": 366,
        "mlsName": "IRMLS",
        "mlsNumber": "202403768",
        "listingAgent": {
            "name": "Allison Washington",
            "phone": "2604376786",
            "email": "allisonlwashington@gmail.com"
        },
        "listingOffice": {
            "name": "North Eastern Group Realty",
            "phone": "2604897095",
            "email": "kim@northeasterngroup.com",
            "website": "http://www.northeasterngroup.com/"
        },
        "history": {
            "2024-02-06": {
                "event": "Sale Listing",
                "price": 356936,
                "listingType": "New Construction",
                "listedDate": "2024-02-06T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 366
            }
        }
    },
    {
        "id": "812-Union-Chapel-Rd,-Fort-Wayne,-IN-46845",
        "formattedAddress": "812 Union Chapel Rd, Fort Wayne, IN 46845",
        "addressLine1": "812 Union Chapel Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/bb099f339c1031097d99ef3b7df04da8-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46845",
        "county": "Allen",
        "latitude": 41.199426,
        "longitude": -85.13113,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1.5,
        "squareFootage": 1611,
        "lotSize": 24829,
        "yearBuilt": 1955,
        "status": "Active",
        "price": 349000,
        "listingType": "Standard",
        "listedDate": "2023-03-30T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2023-03-31T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:59:40.410Z",
        "daysOnMarket": 679,
        "mlsName": "IRMLS",
        "mlsNumber": "202309339",
        "listingAgent": {
            "name": "Greg Conkling",
            "phone": "2607504955",
            "email": "greg@northeasterngroupcr.com"
        },
        "listingOffice": {
            "name": "North Eastern Group Realty",
            "phone": "2604897095",
            "email": "kim@northeasterngroup.com",
            "website": "http://www.northeasterngroup.com/"
        },
        "history": {
            "2023-03-30": {
                "event": "Sale Listing",
                "price": 349000,
                "listingType": "Standard",
                "listedDate": "2023-03-30T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 679
            }
        }
    },
    {
        "id": "604-Merriweather-Psge,-Fort-Wayne,-IN-46845",
        "formattedAddress": "604 Merriweather Psge, Fort Wayne, IN 46845",
        "addressLine1": "604 Merriweather Psge",
        "imgSrc":'https://photos.zillowstatic.com/fp/6ce9829c9780b51fb6a8ed6d4b06e0a7-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46845",
        "county": "Allen",
        "latitude": 41.192661,
        "longitude": -85.134445,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 2.5,
        "squareFootage": 2346,
        "lotSize": 10454,
        "yearBuilt": 2022,
        "hoa": {
            "fee": 50
        },
        "status": "Active",
        "price": 435752,
        "listingType": "New Construction",
        "listedDate": "2022-12-09T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-31T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:59:40.401Z",
        "daysOnMarket": 790,
        "mlsName": "IRMLS",
        "mlsNumber": "202249225",
        "listingAgent": {
            "name": "Jamie Lancia",
            "phone": "2604894433",
            "email": "jamie@lanciahomes.com",
            "website": "http://www.lanciahomes.com"
        },
        "listingOffice": {
            "name": "Lancia Homes And Real Estate",
            "phone": "2604894433",
            "email": "janiece@lanciahomes.com",
            "website": "http://www.lanciahomes.com"
        },
        "history": {
            "2022-12-09": {
                "event": "Sale Listing",
                "price": 435752,
                "listingType": "New Construction",
                "listedDate": "2022-12-09T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 790
            }
        }
    },
    {
        "id": "7832-Coldwater-Rd,-Fort-Wayne,-IN-46825",
        "formattedAddress": "7832 Coldwater Rd, Fort Wayne, IN 46825",
        "addressLine1": "7832 Coldwater Rd",
        "imgSrc":'https://photos.zillowstatic.com/fp/7659e328ad947f9fb7db8631fee01e8a-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46825",
        "county": "Allen",
        "latitude": 41.152255,
        "longitude": -85.135974,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 1.5,
        "squareFootage": 1869,
        "lotSize": 57064,
        "yearBuilt": 1957,
        "status": "Active",
        "price": 525000,
        "listingType": "Standard",
        "listedDate": "2023-04-05T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2022-05-03T11:11:00.784Z",
        "lastSeenDate": "2025-02-05T10:59:40.267Z",
        "daysOnMarket": 673,
        "mlsName": "IRMLS",
        "mlsNumber": "202310014",
        "listingAgent": {
            "name": "Tony Chacon",
            "phone": "2604336212",
            "email": "chacontony@yahoo.com"
        },
        "listingOffice": {
            "name": "Attraction Realty, LLC",
            "phone": "2604978900",
            "email": "chacontony@yahoo.com"
        },
        "history": {
            "2023-04-05": {
                "event": "Sale Listing",
                "price": 525000,
                "listingType": "Standard",
                "listedDate": "2023-04-05T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 673
            }
        }
    },
    {
        "id": "5690-Gadwall-Pass,-Fort-Wayne,-IN-46818",
        "formattedAddress": "5690 Gadwall Pass, Fort Wayne, IN 46818",
        "addressLine1": "5690 Gadwall Pass",      
        "imgSrc":'https://photos.zillowstatic.com/fp/1c03c43f660befc90f3fb980a28f6094-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46818",
        "county": "Allen",
        "latitude": 41.189084,
        "longitude": -85.217359,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2.5,
        "squareFootage": 2580,
        "lotSize": 19166,
        "yearBuilt": 2021,
        "hoa": {
            "fee": 37
        },
        "status": "Active",
        "price": 559900,
        "listingType": "Standard",
        "listedDate": "2024-06-07T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-05T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:57:51.706Z",
        "daysOnMarket": 244,
        "mlsName": "MIBOR",
        "mlsNumber": "21983982",
        "listingAgent": {
            "name": "Denise Sinn",
            "phone": "3178478550",
            "email": "dasinngltd@aol.com",
            "website": "http://www.denisesinn.com"
        },
        "listingOffice": {
            "name": "Keller Williams Indy Metro S",
            "phone": "3175843117",
            "email": "hometown@kw.com"
        },
        "history": {
            "2024-06-07": {
                "event": "Sale Listing",
                "price": 559900,
                "listingType": "Standard",
                "listedDate": "2024-06-07T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 244
            }
        }
    },
    {
        "id": "14170-Escondida-Cv,-Fort-Wayne,-IN-46845",
        "formattedAddress": "14170 Escondida Cv, Fort Wayne, IN 46845",
        "addressLine1": "14170 Escondida Cv",
        "imgSrc":'https://photos.zillowstatic.com/fp/561104e28d5d49a70ae3ddacbb9982a7-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46845",
        "county": "Allen",
        "latitude": 41.212991,
        "longitude": -85.165986,
        "propertyType": "Single Family",
        "bedrooms": 4,
        "bathrooms": 2.5,
        "squareFootage": 2346,
        "lotSize": 10149,
        "yearBuilt": 2024,
        "hoa": {
            "fee": 50
        },
        "status": "Active",
        "price": 389400,
        "listingType": "New Construction",
        "listedDate": "2024-08-01T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-08-02T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:57:51.697Z",
        "daysOnMarket": 189,
        "mlsName": "IRMLS",
        "mlsNumber": "202428868",
        "listingAgent": {
            "name": "Allison Washington",
            "phone": "2604376786",
            "email": "allisonlwashington@gmail.com"
        },
        "listingOffice": {
            "name": "North Eastern Group Realty",
            "phone": "2604897095",
            "email": "kim@northeasterngroup.com",
            "website": "http://www.northeasterngroup.com/"
        },
        "history": {
            "2024-08-01": {
                "event": "Sale Listing",
                "price": 389400,
                "listingType": "New Construction",
                "listedDate": "2024-08-01T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 189
            }
        }
    },
    {
        "id": "975-Zenos-Blvd,-Fort-Wayne,-IN-46818",
        "formattedAddress": "975 Zenos Blvd, Fort Wayne, IN 46818",
        "addressLine1": "975 Zenos Blvd",
        "imgSrc":'https://photos.zillowstatic.com/fp/c895f350d25d40d9a9d5a048377f314f-cc_ft_768.webp',
  
        "addressLine2": null,
        "city": "Fort Wayne",
        "state": "IN",
        "zipCode": "46818",
        "county": "Allen",
        "latitude": 41.1491,
        "longitude": -85.247833,
        "propertyType": "Single Family",
        "bedrooms": 3,
        "bathrooms": 2,
        "squareFootage": 1464,
        "lotSize": 13504,
        "yearBuilt": 2024,
        "hoa": {
            "fee": 41
        },
        "status": "Active",
        "price": 379900,
        "listingType": "New Construction",
        "listedDate": "2024-07-23T00:00:00.000Z",
        "removedDate": null,
        "createdDate": "2024-01-11T00:00:00.000Z",
        "lastSeenDate": "2025-02-05T10:57:51.695Z",
        "daysOnMarket": 198,
        "mlsName": "IRMLS",
        "mlsNumber": "202427367",
        "listingAgent": {
            "name": "Elizabeth Urschel",
            "phone": "2603991177",
            "email": "eurschel@graniteridgebuilders.com"
        },
        "listingOffice": {
            "name": "CENTURY 21 Bradley Realty, Inc.",
            "phone": "2603991177",
            "email": "leadership@c21bradley.com",
            "website": "http://century21bradley.com/"
        },
        "history": {
            "2024-07-23": {
                "event": "Sale Listing",
                "price": 379900,
                "listingType": "New Construction",
                "listedDate": "2024-07-23T00:00:00.000Z",
                "removedDate": null,
                "daysOnMarket": 198
            }
        }
    }
  ]
  
  const combinedListings = [...currentListingsMemphis, ...currentListingsFortWayne, ...currentListingsAugusta, ...currentListingsBirmingham, ...currentListingsLittleRock];
  
  
  
  
  // Shuffle function using Fisher-Yates algorithm
  const shuffleArray = (array) => {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };
  
  const randomizedListings = shuffleArray(combinedListings);
  
  useEffect(() => {
    setTimeout(() => {
      firebase
        .firestore()
        .collection("users")
        .doc(currentUser.uid)
        .get()
        .then((snapshot) => {
          if (snapshot.exists) {
            setUser(snapshot.data());
            console.log("USERID", currentUser.uid);
            console.log("USER", user);
          } else {
            console.log("does not exist");
          }
        });
    }, 1000);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResultData(null);

    try {
      const response = await axios.post(
        'https://devapi.endato.com/Contact/Enrich',
        {
          FirstName: formData.firstName,
          LastName: formData.lastName,
          Address: {
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
          },
        },
        {
          headers: {
            'galaxy-ap-name': '9c98fe55f8014288bfe14ea5918a433e',
            'galaxy-ap-password': '39b84f31734c4a21be261904d59cddc5',
            'galaxy-search-type': 'DevAPIContactEnrich',
          },
        }
      );
      setResultData(response.data);
    } catch (err) {
      setError('An error occurred while fetching data.');
    }
  };

  if (!user || user.accessToken !== 2) {
    return <div></div>;
  } else
    return (
      <div  style={{ backgroundColor: '#f1f4f9' }}>
      <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'stretch' }}>
  <Sidebar
    style={{
      backgroundColor: '#000222',
      flex: '0 0 250px', // Fixed width for the sidebar
    }}
  >
            <Menu style={{ backgroundColor: '#000222' }}>
              <MenuItem>
                <div style={{ marginLeft: -43, backgroundColor: 'white' }}>
                  <img
                    src="https://i.ibb.co/s2dBvDt/elevate.png"
                    alt="logo"
                    className="ml-4 mt-12 -p-4 "
                    width={300}
                  ></img>
                </div>
              </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white', marginTop: '50px' }} onClick={() => window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'propertylookup'} icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

              <SubMenu label="Education" style={{ backgroundColor: '#000222', color: 'white' }} icon={<SchoolIcon />}>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>
                <MenuItem icon={<AccountBalanceRoundedIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://elevatecoachingrei.com/', "_blank")}>
                  Coaching
                </MenuItem>
                <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                  1-on-1s
                </MenuItem>
                <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                  Day in the Office
                </MenuItem>
                <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                  Ride Along
                </MenuItem>
              </SubMenu>
              <SubMenu label="Tenant Hub" style={{ backgroundColor: '#000222', color: 'white' }} icon={<GroupIcon />}>
                <MenuItem style={{ backgroundColor: 'white', color: '#000222' }} icon={<HouseIcon />}> <OpenModalButton /> </MenuItem>
                <MenuItem style={{ backgroundColor: 'white', color: '#000222' }} icon={<EmojiPeopleIcon />}> <OpenModalButton2 /> </MenuItem>
              </SubMenu>
              <MenuItem icon={<NoteAddIcon />} disabled style={{ backgroundColor: '#000222', color: 'white' }}> Title Setup <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color: '#000222', width: 80, height: 10, fontSize: 8, marginLeft: '-15px', fontWeight: 600, marginTop: '-23px' }} /></MenuItem>
              <MenuItem icon={<GavelIcon />} disabled style={{ backgroundColor: '#000222', color: 'white' }}> Legal Hub <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color: '#000222', width: 80, height: 10, fontSize: 8, marginLeft: '-10px', fontWeight: 600, marginTop: '-23px' }} /></MenuItem>
              <SubMenu label="Insurance Hub" style={{ backgroundColor: '#000222', color: 'white' }} icon={<GppGoodIcon />}>
                <MenuItem icon={<SupportIcon />} onClick={() => window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>
                <MenuItem disabled icon={<CottageIcon />}> Home Warrenties <Chip label={'Coming Soon!'} style={{ backgroundColor: '#000222', color: 'white', width: 80, height: 10, fontSize: 8, marginLeft: '-95px', fontWeight: 600, marginTop: '-23px' }} /></MenuItem>
              </SubMenu>
              <SubMenu label="Business Setup" style={{ backgroundColor: '#000222', color: 'white' }} icon={<BusinessIcon />}>
                <MenuItem icon={<AddIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Form Entity </MenuItem>
                <MenuItem icon={<RequestQuoteIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Taxes </MenuItem>
                <MenuItem icon={<CreditScoreIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Build Credit </MenuItem>
                <MenuItem icon={<LockIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Asset Protection </MenuItem>
                <MenuItem icon={<AttachMoneyIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Business Funding </MenuItem>
              </SubMenu>
              <SubMenu label="Elevate Financial" style={{ backgroundColor: '#000222', color: 'white' }} icon={<PaidIcon />}>
                <MenuItem style={{ backgroundColor: 'white', color: '#000222' }} onClick={() => window.open('https://lendsimpli.com/elevate/', "_blank")} icon={<CurrencyExchangeIcon />}> Loan Portal </MenuItem>
                <MenuItem style={{ backgroundColor: 'white', color: '#000222' }} icon={<SpeedIcon />}> Credit Tradelines </MenuItem>
              </SubMenu>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect: true })}> Logout </MenuItem>
              <div style={{ ...styles.container1, backgroundColor: '#000222' }}>
                <ProfileComponent user={user} />
              </div>
            </Menu>
          </Sidebar>
          <>
            {/* Render the ZillowClonePage with our two-panel map and listings */}
            <div style={{ flex: 1, minHeight: '100vh' }}>
  <ZillowClonePage listings={randomizedListings} />
</div>
          </>
        </div>
      </div>
    );
};

export default DealExplorer2;

// =====================================================================
// Additional inline styles from your existing code
// =====================================================================
const styles = {
  container: {
    margin: '20px auto',
    maxWidth: '600px',
    fontFamily: 'Arial, sans-serif',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width: '100%',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    width: '100%',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  listItemHover: {
    backgroundColor: '#f7f7f7',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  centerScreen: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    minHeight: '100vh'
  },
  container1: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    height: '100%',
    marginTop: '0px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#000222',
    padding: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  profileAvatar: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    marginRight: '21px',
  },
  profileName: {
    fontSize: '17px',
    fontWeight: 'bold',
    color: 'white',
    margin: 0,
  },
  profileHandle: {
    fontSize: '11px',
    color: 'white',
    margin: 0,
  },
};
